/* eslint-disable class-methods-use-this */
/* eslint-disable react/destructuring-assignment */
// Remove those 2 eslint disable
/* eslint-disable react/no-unused-state */
/* eslint-disable react/no-unused-class-component-methods */

/* eslint-disable react/prop-types */
/* eslint-disable no-underscore-dangle */
/* eslint-disable camelcase */
/* eslint-disable jsx-a11y/label-has-associated-control */
import 'app/styles/style.scss';
import 'app/components/Dropzone/style.scss';
import './style.scss';

import produce from 'immer';
import _ from 'lodash';
import memoizeOne from 'memoize-one';
import React, { BaseSyntheticEvent, Fragment, createRef, useContext } from 'react';
import { FormattedDate, FormattedMessage, IntlShape, useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Confirm, Dimmer, Divider, Icon, Label, Loader, Popup } from 'semantic-ui-react';
import { v4 } from 'uuid';

import MeasurementTools from 'app/components/Dropzone/MeasurementTools';
import PatientInfoModal from 'app/components/Dropzone/PatientInfoModal';
import { UPPER_TOOLS_BAR_TOOLS_LISTS } from 'app/components/Dropzone/constants';
import { createCommonToolsList } from 'app/components/Dropzone/utils';
import EditableReport from 'app/components/EditableReport';
import {
  FlatPanelState,
  FlatPanelStateContext,
  getCurrentDetector,
  getCurrentDetectorState,
} from 'app/components/FlatPanelStateProvider';
import PatientInfoBar from 'app/components/PatientInfoBar';
import ToolsBar from 'app/components/ToolsBar';
import FullSizeConfigurationButton from 'app/components/ToolsBar/FullSizeConfigurationButton';
import imagesReducer, {
  addWorkListImage,
  cacheInitialContent,
  cancelRealSizeCalibration,
  changeAnnotationsVisibility,
  changeNegatoMode,
  confirmRealSizeCalibration,
  deleteImage,
  switchGeneratorError,
  enableConfigurableFilterParameters,
  imageLoadFailure,
  imageLoadStart,
  imageLoadSuccess,
  imageSelect,
  injectStudyInState,
  loadStudy,
  loadWorkListImage,
  pacsEndSync,
  pacsStartSync,
  predictionsLoadFailure,
  predictionsLoadStart,
  predictionsLoadSuccess,
  processingDone,
  processingFineTuningToggle,
  processingStart,
  receiveAcquiredImage,
  redoImage,
  removeAnnotation,
  resetRealSizeCalibration,
  selectNegatoView,
  selectNextWorklistImage,
  setActiveRegion,
  setImageAntiScatteringGrid,
  setRawDataSaved,
  setRotationAngle,
  setStudyDefaultAntiScatteringGrid,
  switchRealSizeCalibration,
  toggleFreeRotation,
  updateAcquisitionConstants,
  updateAnatomicRegion,
  updateAnnotation,
  updateConfigurableFilterParameters,
  updateDisplayableMetadata,
  updateFeedback,
  updateFinetunedProcessedImage,
  updateOperators,
  updatePatient,
  updateProcessingOptions,
  updateToolsStates,
  updateViewport,
  useOtherImageCalibration,
} from 'app/components/Viewer/reducer';
import { rejectImageDeletionEffect } from 'app/components/Viewer/useImagesEffect';
import WhatImagesToSend from 'app/components/WhatImagesToSend';
import ObjectIdGenerator from 'app/interfaces/ObjectIdGenerator';
import {
  selectTeleradiologyExportSettings,
  ExportOptions,
  selectFileExportSettings,
  selectPacsExportSettings,
} from 'app/redux/exportSettings';
import createDeferredPromise from 'app/utils/createDeferredPromise';
import { getDicomDataValue, getPixelSpacing } from 'app/utils/dicom/DicomData';
import PredictionsDisplay from './PredictionsDisplay';

import { isVisibleToolState } from 'app/CornerstoneTools/constants';
import { DataLossGuardConnectorContext } from '../DataLossGuard/DataLossGuardConnectorContext';
import CountDown from 'app/components/Dropzone/CountDown';
import ExportStudyModal from 'app/components/Dropzone/ExportStudyModal';
import FileWatcher from 'app/components/FileWatcher';
import FlatPanelList from 'app/components/FlatPanelList';
import FoldableAIPanel from 'app/components/FoldableAIPanel';
import { PACSCommunicationContext } from '../PACSCommunicationProvider/context';
import Snipper from 'app/components/Snipper';
import UseEffect from 'app/hooks/components/UseEffect';
import UseImagesEffect from 'app/hooks/components/UseImagesEffect';
import UserDisplayableError from 'app/interfaces/UserDisplayableError';
import xray from 'app/native/node-addons/xray';
import {
  PACSConfigurationState,
  isPACSConfigurationDisabled,
  selectPACSConfiguration,
} from 'app/redux/PACSConfiguration/reducer';
import { DETECTOR_EVENTS } from 'app/types/xray';
import MaxDurationPromise from 'app/utils/MaxDurationPromise';
import PROCESSING_OPTIONS from 'app/utils/PROCESSING_OPTIONS';
import { computeScaleFactorFromStoredViewport } from 'app/utils/cornerstone/imageUtils';
import logger from 'app/utils/debug/logger';
import convertDisplayableImageDataToDataImage from 'app/utils/image/convertDisplayableImageDataToDataImage';
import getProcessingKeyFromInfo from 'app/utils/imageProcessing/getProcessingKeyFromInfo';
import isDataImageProcessable from 'app/utils/imageProcessing/isDataImageProcessable';
import { isAcquisitionImage } from 'app/utils/isAcquisitionImage';
import isWorkListImage from 'app/utils/isWorkListImage';
import loadDemoImages from 'app/utils/loadDemoImages';
import { DEFAULT_SPECIE } from 'app/constants/species';
import {
  getAnatomicRegionFromString,
  getProcessingFromAnatomicRegion,
} from 'app/utils/xrayRegions';
import { ANNOTATION_SAVE_DELAY, INFERENCE_GUARD_TIMEOUT } from './constants';
import XRayAreaView from 'app/components/XRayAreaView';
import XRayGeneratorStatus from 'app/components/XRayGeneratorStatus';
import { PMSExportContext } from 'app/providers/PMSIntegration/PMSExportProvider';
import disableAllComponentMethodsOnUnmount from 'app/utils/react/disableAllComponentMethodsOnUnmount';
import { UserInputMappingState, selectDicomMapping } from 'app/redux/userInputMapping/reducer';
import ButtonStudySave from 'app/components/Dropzone/ButtonStudySave';
import {
  CompatDropzoneImage,
  CompatDropzoneStudy,
  RawImageSaveData,
  ViewerImage,
  ViewerImages,
  ViewerStudy,
} from 'app/components/Viewer/types';
import { ImageLoader, ImagePath, LoadableImageFile, LoadedImage } from 'app/interfaces/ImageLoader';
import { ImageRenderer } from 'app/interfaces/ImageRenderer';
import { ToolsStates } from 'app/adapters/ImageRenderer/ConfigurableToolsOptions';
import { StudyStore } from 'app/interfaces/StudyStore';
import { Patient } from 'app/interfaces/Patient';
import { DataImage } from 'app/interfaces/DataImage';
import {
  AcquiredDetectorInfo,
  AcquisitionConstants,
  DisplayableImageData,
  ImageOrigin,
  StoredImageInfo,
  XRayImage,
} from 'app/interfaces/Image';
import { CropAnnotation } from 'app/CornerstoneTools/types';
import IDicomBuilder from 'app/interfaces/IDicomBuilder';
import DicomBuilderContext from 'app/providers/DicomBuilder/context';
import { DicomData } from 'app/interfaces/Dicom';
import {
  AIOnlyConfigurationState,
  selectAiOnlyConfiguration,
} from 'app/redux/aiOnlyConfiguration/reducer';
import AddXRayViewModal from 'app/components/Dropzone/AddXRayViewModal';
import { IReportGenerator } from 'app/interfaces/IReportGenerator';
import PACSImagesSelector, { PACSExportOptions } from 'app/components/Dropzone/PACSImagesSelector';
import { formatViewerImagesToSelectableImages } from 'app/components/Dropzone/formatStudyForExportModal';
import { TaskHandler, TaskScheduler } from 'app/utils/async/TaskScheduler';
import ParallelTaskScheduler from 'app/utils/async/ParallelTaskScheduler';
import DataSaveEffect from 'app/components/DataSaveEffect';
import { MainImageRenderer } from 'app/components/MainImageRenderer';
import computeDisplayedImageMetadata from 'app/components/Viewer/computeDisplayedImageMetadata';
import { convertRectToCropHandles } from 'app/CornerstoneTools/CropTool';
import { IDisplayableImageEncoder } from 'app/interfaces/IDisplayableImageEncoder';
import {
  convertCropAnnotationToCropRect,
  convertCropAnnotationsToCropRect,
} from 'app/utils/image/convertCropAnnotationsToCropRect';
import IDisplayableImageEncoderContext from 'app/providers/IDisplayableImageEncoder/context';
import NegatoButton, { NegatoMode, NEGATO_MODE_INFO } from 'app/components/ToolsBar/NegatoButton';
import { AllPredictions, BadPredictions } from 'app/interfaces/Predictions';
import TeleradiologyPanel from 'app/containers/Teleradiology/Panel';
import formatStudyImagesForTeleradiology from 'app/components/Viewer/formatStudyImagesForTeleradiology';
import { isFullResolutionDicom } from './isFullResolutionDicom';
import { ImagesType as PMSImagesType, PMSExportFn } from 'app/pms/exporter/PmsExporter';
import ToolValidationOverlay from 'app/components/Dropzone/ToolValidationOverlay';
import XRayOperatorSelector from 'app/components/XRayOperatorSelector';
import RealSizeMeasurementConfigurationButton from 'app/components/ToolsBar/RealSizeMeasurementConfigurationButton';
import convertDataImageToDisplayableImageData from 'app/utils/image/convertDataImageToDisplayableImageData';
import { generateRawUint16ImageId } from 'app/utils/cornerstone/loadImage';
import ComputationCache from 'app/utils/cache/ComputationCache';
import { IImageProcessor, ProcessingKind, ProcessingOptions } from 'app/interfaces/IImageProcessor';
import { PACSCommunication } from 'app/interfaces/PACSCommunication';
import { selectCurrentImageId, selectCurrentStudyId } from 'app/redux/currentStudyInfos/reducer';
import { Dispatch } from 'redux';
import { setImageId, setStudyId } from 'app/redux/currentStudyInfos/actions';
import {
  ViewerConfigurationState,
  selectViewerConfiguration,
  setRealSizeMeasurementDefaultLength,
} from 'app/redux/viewerConfiguration/reducer';
import importDicomStudy from 'app/utils/dicom/importDicomStudy';
import makeDicomImageFromDetailsAndViewport, {
  DicomExportableImage,
} from 'app/dicom/makeDicomImageFromDetailsAndViewport';
import AcquisitionGeneratorErrorWarning from 'app/components/Viewer/AcquisitionGeneratorErrorWarning';
import extractVisibleAnnotations from 'app/utils/image/extractVisibleAnnotations';
import syncImageWithPACS from 'app/dicom/syncImageWithPACS';
import { isOk } from 'app/type-utils/Result';
import convertCropAnnotationToCropRectWithScale from 'app/utils/image/convertCropAnnotationToCropRectWithScale';
import buildProcessingOptions from 'app/utils/image/buildProcessingOptions';
import { selectXRaySelectedOperators } from 'app/redux/xrayGeneratorConfiguration/reducer';
import { XRayGeneratorControllerContext } from 'app/providers/XRayGeneratorProvider';
import { EVENT_GENERATOR_SWITCH } from 'app/xray/generator/constants';
import { useAnatomicRegionSynchronyzer } from 'app/providers/AnatomicRegionProvider';
import { addListener, UnknownAction } from '@reduxjs/toolkit';
import isAnyImagePresentInImages from 'app/components/Viewer/utils/isAnyImagePresentInImages';
import ThumbnailsList from 'app/components/Viewer/components/LeftPanel/ThumbnailsList';
import FilterParametrization, {
  FilterDescription,
} from 'app/components/Viewer/components/RightPanel/FilterParametrization';
import ImageComparator from 'app/components/ImageComparator';
import { ProcessingDropdownButtonProps } from 'app/components/ToolsBar/ProcessingListButton';
import {
  ProcessingState,
  removeFilter,
  selectProcessingFilters,
  StoredFilterDescription,
  updateFilter,
} from 'app/redux/processing/reducer';
import useProcessingOptionsProvider, {
  ProcessingOptionsProvider,
} from 'app/hooks/useProcessingOptionsProvider';
import {
  selectRotationHistory,
  recordRotation,
  selectRotationMode,
  selectFixedRotationAngle,
} from 'app/redux/rotationHistory/reducer';
import type { RotationMode, FixedRotationAngle } from 'app/redux/rotationHistory/reducer';
import {
  getSpeciesAgnosticRegionKey,
  getMostFrequentRotation,
  normalizeRotation,
} from 'app/utils/rotationHistory';
import { ClinicInfo, selectClinicInfo } from 'app/redux/clinicInfo/reducer';
import { Toggle } from 'rsuite';

const findFirstLoadErrorIndex = (images: ViewerImages) => _.findKey(images, 'loadError');

type LoadImagePromise<R> = Promise<R> & { load?: () => Promise<R> };
const createLoadImagePromise = <R extends unknown>(
  loadFn: () => Promise<R>
): LoadImagePromise<R> => {
  const deferredLoad: LoadImagePromise<R> & DeferredPromise<R> = createDeferredPromise();
  deferredLoad.load = async () => loadFn().then(deferredLoad.resolve).catch(deferredLoad.reject);

  return deferredLoad;
};

type LoadingPromisesRegistry = {
  [imageId: string]: LoadImagePromise<LoadedImage>;
};

const isProcessingForImageNeeded = (loadedImage: LoadedImage, imageDescriptor: ViewerImage) => {
  const processingType = imageDescriptor?.image_metadata?.processingType;
  if (loadedImage.isNotProcessable) return false;
  if (processingType === undefined) return false;

  const { imageData } = loadedImage;
  const { getPixelData, color } = imageData ?? {};

  if (color) return false;

  const pixelData = getPixelData?.();

  if (!pixelData) return false;
  if (!(pixelData instanceof Uint16Array)) return false;

  return true;
};

type ProcessingCache = ComputationCache<[DataImage, ProcessingOptions], Promise<DataImage>>;

type CachedProcessFunction = (
  savedStudyId: string,
  imageId: string,
  rawImage: DataImage,
  options: ProcessingOptions
) => Promise<DataImage>;

const processLoadingImage = async (
  studyId: string,
  imageId: string,
  loadedImage: LoadedImage,
  imageDescriptor: ViewerImage,
  processWithCache: CachedProcessFunction,
  processingCache: ProcessingCache,
  processingOptionsProvider: ProcessingOptionsProvider
) => {
  const { imageData, processedImage: preProcessedImage, dicomData } = loadedImage;
  const { width, height } = imageData ?? {};

  const dataImage = convertDisplayableImageDataToDataImage(loadedImage.imageData);
  const processingOptions = buildProcessingOptions(imageDescriptor, {
    processingOptionsProvider,
    photometricInterpretation: getDicomDataValue(dicomData, 'PhotometricInterpretation'),
    imageDimensions: width !== undefined && height !== undefined ? { width, height } : undefined,
  });
  console.debug('Processing options for image', imageId, processingOptions);
  if (preProcessedImage) {
    processingCache.setCacheEntry([dataImage, processingOptions], preProcessedImage);
    // // We have to forward the viewport gamma from processing options in case one was provided
    // let processedImage: DataImage & ViewportDisplayOptions = preProcessedImage;

    // if (processingOptions?.viewport) {
    //   console.debug('Applying viewport from processing options', processingOptions.viewport);
    //   processedImage = { ...processedImage, viewport: processingOptions.viewport };
    // }
    return { processedImage: preProcessedImage, isFromLastProcessing: true };
  }

  const processedImage = await processWithCache(studyId, imageId, dataImage, processingOptions);
  return { processedImage, isFromLastProcessing: false };
};

type ProcessOptions = {
  processingType: ProcessingKind | string;
  cropRect?: number[];
  photometric_interpretation?: string;
  processingFilters?: StoredFilterDescription[];
  has_anti_scattering_grid?: boolean;
};
type ProcessFunction = (
  imageId: string,
  pixelContent: DataImage,
  options: ProcessOptions
) => Promise<void>;

const triggerProcessOnCrop = (
  toolName: string,
  measurementData: CropAnnotation,
  imageId: string,
  pixelContent: DataImage,
  {
    processingType,
    photometric_interpretation,
  }: { processingType: ProcessingKind | string; photometric_interpretation: string },
  processFn: ProcessFunction
) => {
  if (toolName !== 'Crop') return;
  if (!(pixelContent?.data instanceof Uint16Array)) return;
  if (!processingType) return;

  const cropRect = convertCropAnnotationToCropRect(measurementData);

  processFn(imageId, pixelContent, { processingType, photometric_interpretation, cropRect });
};

const preventDefault = (e: BaseSyntheticEvent) => e.preventDefault();

const enhanceAnatomicDefaultBasedOnImageInfo = (
  anatomicDefault: string,
  anatomicRegionWithSpecie: string
) => {
  const { specie, mainRegion } = getAnatomicRegionFromString(anatomicRegionWithSpecie);
  // Speciefic processing for dog skull that makes our default 'bones' button kind of complicated
  if (anatomicDefault === 'bones' && mainRegion === 'crane' && specie === 'dog') {
    return 'bones crane';
  }
  return anatomicDefault;
};

const doesProcessingTypeMatchProcessingKey = (processingType: string, processingKey: string) =>
  processingType?.includes(processingKey) ||
  (processingType?.includes('skull') && processingKey === 'bones');

export type ViewerProps = {
  imageLoader: ImageLoader;
  imageProcessor: IImageProcessor;
  objectIdGenerator: ObjectIdGenerator;
  xRayGeneratorController?: XRayGeneratorController;
  reportGenerator: IReportGenerator;
  studyStore: StudyStore;
  patientStore: PatientStore;
  inferenceExecutor: InferenceExecutor;
  initialStudyIds?: string[];
  initialStudyInstanceUids?: string[];
  imagePaths?: ImagePath[];
  importedImages?: ImagePath[];
  initialPatientInfo?: Patient;
  mode?: 'acquisition';
  history?: any; // BrowserHistory compatible
  onImagePathsAcknowledged?: (imagePaths: ImagePath[]) => void;
  onImportedImagesFromAnotherStudy: (imageFiles: LoadableImageFile[]) => void;
  hideHeader: (shouldHideHeader: boolean) => void;
};

export type ViewerImplProps = ViewerProps & {
  intl: IntlShape;
  // Context
  viewerConfiguration: ViewerConfigurationState;
  imageEncoder: IDisplayableImageEncoder;
  dicomBuilder: IDicomBuilder;
  anatomicRegionSynchronizer: ReturnType<typeof useAnatomicRegionSynchronyzer>;
  exportToPMS?: PMSExportFn;
  dataLossGuard?: DataLossGuardConnector;
  pacsCommunication?: PACSCommunication;
  processingFilters?: ProcessingState['filters'];
  processingOptionsProvider: ProcessingOptionsProvider;
  PACSConfiguration?: PACSConfigurationState;
  dicomMapping?: UserInputMappingState['dicomMapping'];
  flatPanelState?: FlatPanelState;
  selectedOperators?: string[];
  aiOnlyConfiguration: AIOnlyConfigurationState;
  selectedCurrentStudyId?: string;
  selectedCurrentImageId?: string;
  teleradiologyExportSettings: ExportOptions;
  fileExportSettings: ExportOptions;
  pacsExportSettings: ExportOptions;
  reduxDispatch: Dispatch<any>;
  rotationHistory: Record<string, number[]>;
  rotationMode: RotationMode;
  fixedRotationAngle: FixedRotationAngle;
  clinicInfo?: ClinicInfo;
};

export type ReportState = {
  comment: string;
  isCommentDirty: boolean;
};

export type ViewerState = {
  studies: Record<string, ViewerStudy>;

  isFullScreen: boolean;
  isFullSizeConfiguration: boolean;
  showAnnotations: boolean;
  acquisitionCountDown?: number;
  studyLoadFailedConfirmOpen: boolean;
  commonToolsList: ToolsStates;
  negatoMode: NegatoMode;
  selectedNegatoView: number;
  pendingImageIdDeletion?: string;
};

const isProcessingCacheKeysEquals = (
  [image1, options1]: [DataImage, ProcessingOptions],
  [image2, options2]: [DataImage, ProcessingOptions]
) => {
  return image1.data === image2.data && _.isEqual(options1, options2);
};

class ViewerImpl extends React.Component<ViewerImplProps, ViewerState> {
  private imageLoadingScheduler: TaskScheduler;
  private imagesLoadingHandlers: { [imageId: string]: TaskHandler } = {};
  private fileInputRef: React.RefObject<HTMLInputElement>;
  private renderers: ImageRenderer[] = [];
  private comparatorRenderers: ImageRenderer[] = [];
  private imageLoadingPromises: LoadingPromisesRegistry = {};
  private acquisitionIntervalRef: number | undefined = undefined;
  private pendingImageFiles: [string, LoadableImageFile][] = [];
  private pendingFullSizeScaleCb: Record<string, () => void> = {};
  private isAutoImportNewStudyChangePending: boolean = false;
  private memoizedCalls: { [memoizationKey: string]: any } = {};
  private processingCache;
  private ongoingPACSSyncRequest: { [imageId: string]: Promise<any> } = {};
  private debouncedProcessImageFineTuned: typeof this.processFineTunedImage;
  private fineTuningProcessingScheduler: TaskScheduler = new ParallelTaskScheduler(1);

  constructor(props: ViewerImplProps) {
    super(props);
    const { objectIdGenerator, intl } = this.props;

    const baseStudy: ViewerStudy = {
      _id: objectIdGenerator.create(),
      images: [],
      creationDate: new Date(),
      patient: { specie: DEFAULT_SPECIE },
      comment: '',
      pms_id: undefined,
      isCommentDirty: false,
    };

    this.state = {
      studies: {},
      isFullScreen: false,
      isFullSizeConfiguration: false,
      showAnnotations: true,
      acquisitionCountDown: undefined,
      studyLoadFailedConfirmOpen: false,
      commonToolsList: createCommonToolsList(() => intl),
      negatoMode: NegatoMode.SINGLE,
      selectedNegatoView: 0,
      pendingImageIdDeletion: undefined,
    };
    injectStudyInState(this.state, baseStudy);

    this.imageLoadingScheduler = new ParallelTaskScheduler(3);
    this.fileInputRef = createRef();
    this.processingCache = new ComputationCache(
      (rawImage: DataImage, options: ProcessingOptions) =>
        this.props.imageProcessor.process(rawImage, options),
      isProcessingCacheKeysEquals
    );

    this.debouncedProcessImageFineTuned = _.debounce(this.processFineTunedImage, 200);
  }

  componentDidMount() {
    const { initialPatientInfo, mode, initialStudyIds, objectIdGenerator, patientStore } =
      this.props;
    if (initialPatientInfo) {
      if (initialPatientInfo._id) {
        patientStore
          .getPatient(initialPatientInfo._id)
          .then((animal: Patient) => this.updateCurrentPatient(animal))
          .catch((e: any) => logger.warn('patient retrieval failed', e));
      } else {
        this.updateCurrentPatient({ specie: DEFAULT_SPECIE, ...initialPatientInfo });
      }
    }
    if (initialStudyIds) return;
    if (mode === 'acquisition') {
      this.dispatch(addWorkListImage({ imageId: objectIdGenerator.create() }));
    }
  }

  componentWillUnmount() {
    disableAllComponentMethodsOnUnmount(this);
    this.props.reduxDispatch(setStudyId(undefined));
    this.props.reduxDispatch(setImageId(undefined));
  }

  componentDidUpdate(
    prevProps: Readonly<ViewerImplProps>,
    prevState: Readonly<ViewerState>,
    snapshot?: any
  ): void {
    if (this.props.selectedCurrentStudyId !== this.currentStudyId) {
      this.props.reduxDispatch(setStudyId(this.currentStudyId));
    }
    if (this.props.selectedCurrentImageId !== this.currentImageId) {
      this.props.reduxDispatch(setImageId(this.currentImageId));
    }
  }

  /* Getters */
  get currentStudyId() {
    return this.useMemo(
      'currentStudyId',
      () =>
        _.find(this.state.studies, (study) => _.some(study.images, 'isSelected'))?._id ??
        Object.keys(this.state.studies)?.[0],
      [_.flattenDeep(_.map(this.state.studies, (study) => _.map(study.images, 'isSelected')))]
    );
  }
  get currentStudy() {
    return (this.state.studies[this.currentStudyId] ?? {}) as ViewerStudy;
  }

  get currentImageId() {
    return this.useMemo(
      'currentImageId',
      () => _.find(this.currentStudy?.images, 'isSelected')?._id,
      [this.currentStudyId, this.currentStudy.images]
    );
  }

  get images() {
    return this.useMemo(
      'images',
      () => _.mapKeys(_.flatten(_.map(this.state.studies, (study) => study.images)), '_id'),
      [this.state.studies]
    );
  }

  get currentImage() {
    return this.images[this.currentImageId];
  }

  get isAnyImagePresent() {
    return this.useMemo('isAnyImagePresent', () => isAnyImagePresentInImages(this.images), [
      this.images,
    ]);
  }

  get isAnyImageLoaded() {
    return _.some(this.images, (image) => !!image);
  }

  get currentImageToolsList() {
    return this.useMemo(
      'getCurrentImageToolsList',
      () =>
        this.currentImage?.toolsList && {
          ...this.state.commonToolsList,
          ...this.currentImage.toolsList,
        },
      [this.currentImage?.toolsList, this.state.commonToolsList]
    );
  }

  get toolsProps() {
    return this.useMemo(
      'toolsProps',
      () => {
        const { intl, processingOptionsProvider } = this.props;
        const {} = this;
        const { isFullScreen, negatoMode, showAnnotations } = this.state;
        const { patient, images } = this.currentStudy;
        const { currentImageId, currentImage } = this;
        const { isRealSizeMeasurementCalibration } = currentImage ?? {};
        const currentProcessingType = processingOptionsProvider.getProcessingOptions(
          currentImage?.image_metadata?.processingType,
          currentImage?.anatomicRegion
        ).id;
        const specie = patient?.specie ?? DEFAULT_SPECIE;

        const isCurrentImageProcessable =
          isDataImageProcessable(currentImage?.initialDataImage) && !currentImage?.isNotProcessable;

        const applyCustomFilterProcessing = (processingFilterId: string) => {
          if (currentImage?.image_metadata?.processingType === processingFilterId) return;

          this.processLoadedImage(currentImageId, currentImage?.initialDataImage, {
            // anatomicRegion: currentImage?.anatomicRegion,
            photometric_interpretation: currentImage?.photometric_interpretation,
            processingType: processingFilterId,
            cropRect: convertCropAnnotationToCropRectWithScale(
              currentImage.annotations?.Crop,
              currentImage?.viewport,
              currentImage?.initialDataImage
            ),
          });
        };
        const processLoadedImageByType = (anatomicDefault: string) => {
          const enhancedAnatomicDefault = enhanceAnatomicDefaultBasedOnImageInfo(
            anatomicDefault,
            currentImage?.anatomicRegion
          );
          const processingType = processingOptionsProvider.getProcessingOptions(
            undefined,
            `${specie} ${enhancedAnatomicDefault}`
          ).id;

          return applyCustomFilterProcessing(processingType);
        };

        const isCurrentProcessing = (anatomicDefault: string) => {
          const enhancedAnatomicDefault = enhanceAnatomicDefaultBasedOnImageInfo(
            anatomicDefault,
            currentImage?.anatomicRegion
          );
          const processingType = processingOptionsProvider.getProcessingOptions(
            undefined,
            `${specie} ${enhancedAnatomicDefault}`
          ).id;

          return currentProcessingType === processingType;
        };

        const hasRealSizeMeasurementCalibration =
          Object.values(currentImage?.annotations?.RealSizeMeasurementCalibration ?? {})?.[0] !==
          undefined;
        const realSizeMeasurementCalibrationReference =
          currentImage?.image_metadata?.realSizeMeasurementImageReference;

        // Disable options if a real size measurement calibration exists
        const realSizeMeasurementCalibrationOptions = hasRealSizeMeasurementCalibration
          ? undefined
          : _.map(images, (image) => {
              const imageId = image._id;
              const hasRealSizeMeasurementCalibration =
                Object.values(image?.annotations?.RealSizeMeasurementCalibration ?? {})?.[0] !==
                undefined;
              if (!hasRealSizeMeasurementCalibration) return undefined;
              return {
                title: (
                  <FormattedMessage
                    id="tools.real_size.calibration_option"
                    values={{ index: images.indexOf(image) + 1 }}
                  />
                ),
                callback: () =>
                  this.dispatch(
                    useOtherImageCalibration({ imageId: currentImageId, otherImageId: imageId })
                  ),
                isSelected: realSizeMeasurementCalibrationReference === imageId,
              };
            }).filter(_.identity);

        return {
          AnnotationsDisplaySwitch: {
            showAnnotations,
            onSwitchAnnotationState: this.onSwitchShownAnnotationsTools,
          },
          FullScreen: { isFullScreen, switchFullScreen: this.switchFullScreen },
          PicoxiaAnalysis: {
            isImageModified: currentImage?.isImageNewPredictionsNeeded,
            onClick: this.refreshInferenceOnCurrentImage,
          },
          FullSizeConfiguration: {
            content: (
              <FullSizeConfigurationButton
                applyFullSize={(scale: number) => {
                  this.dispatch(
                    updateViewport({ imageId: this.currentImageId, viewport: { scale } })
                  );
                }}
                viewerImage={this.currentImage}
                triggerRealSizeMeasurementCalibration={(onSuccess) => {
                  this.switchRealSizeMeasurementCalibration(currentImageId);
                  this.pendingFullSizeScaleCb[currentImageId] = onSuccess;
                }}
              />
            ),
          },
          FreeRotation: {
            isFreeRotationActive: currentImage?.isFreeRotationActive,
            toggleFreeRotation: (shouldActivate: boolean) =>
              this.dispatch(toggleFreeRotation({ imageId: currentImageId, isOn: shouldActivate })),
            setRotationAngle: (angle: number) =>
              this.dispatch(setRotationAngle({ imageId: currentImageId, angle })),
          },
          RealSizeMeasurementCalibration: {
            content: (
              <RealSizeMeasurementConfigurationButton
                resetRealSizeMeasurement={() =>
                  this.dispatch(resetRealSizeCalibration({ imageId: currentImageId }))
                }
                isRealSizeMeasurementConfigurationOngoing={isRealSizeMeasurementCalibration}
                toggleRealSizeMeasurementConfiguration={() =>
                  this.switchRealSizeMeasurementCalibration(currentImageId)
                }
                calibrationOptions={realSizeMeasurementCalibrationOptions}
              />
            ),
          },
          Negato: {
            content: (
              <NegatoButton
                currentMode={negatoMode}
                onNegatoSelect={(negatoMode) => this.dispatch(changeNegatoMode({ negatoMode }))}
              />
            ),
          },
          Processing: {
            isShown: isCurrentImageProcessable,
            onFineTuningClick: (isEnabled) => {
              this.dispatch(
                enableConfigurableFilterParameters({
                  imageId: currentImageId,
                  isEnabled,
                  processingOptionsProvider: this.props.processingOptionsProvider,
                })
              );
            },
            isFineTuning: currentImage?.isFilterFineTuning,
            isGridEnabled: currentImage?.image_metadata?.has_anti_scattering_grid ?? false,
            onToggleGrid: () => {
              const isGridEnabled = currentImage?.image_metadata?.has_anti_scattering_grid ?? false;
              const newGrid = !isGridEnabled;
              this.dispatch(
                setImageAntiScatteringGrid({ imageId: currentImageId, hasGrid: newGrid })
              );
              if (!currentImage?.initialDataImage) return;
              const currentProcessingType =
                currentImage?.image_metadata?.processingType ?? 'default';
              this.processLoadedImage(currentImageId, currentImage.initialDataImage, {
                photometric_interpretation: currentImage?.photometric_interpretation,
                processingType: currentProcessingType,
                cropRect: convertCropAnnotationToCropRectWithScale(
                  currentImage.annotations?.Crop,
                  currentImage?.viewport,
                  currentImage?.displayableImage
                ),
                has_anti_scattering_grid: newGrid,
              });
            },
            processingList: {
              default: {
                key: 'default',
                label: intl.formatMessage({ id: 'tools.processing.default_filter.label' }),
                callback: () => processLoadedImageByType('default'),
                isCurrentProcessing: isCurrentProcessing('default'),
              },
              abdomen: {
                key: 'abdomen',
                label: intl.formatMessage({ id: 'tools.processing.abdomen_filter.label' }),
                callback: () => processLoadedImageByType('abdomen'),
                isCurrentProcessing: isCurrentProcessing('abdomen'),
              },
              bones: {
                key: 'bones',
                label: intl.formatMessage({ id: 'tools.processing.bones_filter.label' }),
                callback: () => processLoadedImageByType('bones'),
                isCurrentProcessing: isCurrentProcessing('bones'),
              },
              thorax: {
                key: 'thorax',
                label: intl.formatMessage({ id: 'tools.processing.thorax_filter.label' }),
                callback: () => processLoadedImageByType('thorax'),
                isCurrentProcessing: isCurrentProcessing('thorax'),
                processedImage: undefined,
              },
              ..._.fromPairs(
                _.map(
                  _.sortBy(this.props.processingFilters, (filter) => filter.name.toLowerCase()),
                  (filter) => [
                    filter.id,
                    {
                      key: filter.id,
                      label: filter.name,
                      callback: () => applyCustomFilterProcessing(filter.id),
                      isCurrentProcessing:
                        currentImage?.image_metadata?.processingType === filter.id,
                      onEditClick: () =>
                        this.dispatch(
                          enableConfigurableFilterParameters({
                            imageId: currentImageId,
                            isEnabled: !currentImage?.isFilterFineTuning,
                            processingFilterId: filter.id,
                            processingOptionsProvider: this.props.processingOptionsProvider,
                          })
                        ),
                    },
                  ]
                )
              ),
            },
          } as Partial<ProcessingDropdownButtonProps>,
        };
      },
      [
        this.props.intl,
        this.props.viewerConfiguration,
        this.state.isFullScreen,
        this.currentStudy.patient,
        this.state.negatoMode,
        this.state.isFullSizeConfiguration,
        this.currentImageId,
        this.currentImage,
      ]
    );
  }

  getStudyForImageId = (
    imageId: string,
    studies: Record<string, ViewerStudy> = undefined
  ): ViewerStudy | undefined => {
    return _.find(studies ?? this.state.studies, ({ images }) =>
      _.some(images ?? [], { _id: imageId })
    );
  };

  getImageIndex = (imageId: string) => {
    const study = this.getStudyForImageId(imageId);
    return study?.images?.findIndex(({ _id }) => _id === imageId);
  };

  getImageForImageId = (
    imageId: string,
    studies: Record<string, ViewerStudy> = undefined
  ): ViewerImage | undefined => {
    for (const study of Object.values(studies ?? this.state.studies)) {
      for (const image of study.images) {
        if (image._id === imageId) {
          return image;
        }
      }
    }
    return undefined;
  };

  getSingleStudy = (studies: Record<string, ViewerStudy> = undefined) => {
    const studyCount = Object.keys(studies ?? this.state.studies).length;
    return studyCount === 1 ? Object.values(studies ?? this.state.studies)[0] : undefined;
  };

  /* Getters end */

  // Reducer dispatcher
  dispatch = (action: UnknownAction, callback?: () => void) => {
    return this.setState(
      // eslint-disable-next-line react/destructuring-assignment
      (draftState) => imagesReducer(draftState, action),
      callback
    );
  };

  /* Helper functions */

  useMemo = <T extends (...args: Parameters<T>) => ReturnType<T>>(
    fnName: string,
    callback: T,
    deps: any[]
  ): ReturnType<T> => {
    const memoizationName = `${fnName}_memo`;
    this.memoizedCalls[memoizationName] ??= memoizeOne((...args: Parameters<T>) =>
      callback(...args)
    );
    return this.memoizedCalls[memoizationName](...deps);
  };

  /* Start state setters */

  setImageForDeletion = (imageId: string) => this.setState({ pendingImageIdDeletion: imageId });

  switchFullScreen = () => this.setState(({ isFullScreen }) => ({ isFullScreen: !isFullScreen }));

  switchFullSizeConfiguration = () =>
    this.setState(({ isFullSizeConfiguration }) => ({
      isFullSizeConfiguration: !isFullSizeConfiguration,
    }));

  switchRealSizeMeasurementCalibration = (imageId: string, isOn?: boolean, cb?: () => void) => {
    this.dispatch(switchRealSizeCalibration({ imageId, isOn }), cb);
  };

  confirmRealSizeMeasurementCalibration = () => {
    const { currentImageId, currentImage } = this;
    const { reduxDispatch } = this.props;
    this.dispatch(confirmRealSizeCalibration({ imageId: currentImageId }));
    this.switchRealSizeMeasurementCalibration(currentImageId, false, () => {
      this.pendingFullSizeScaleCb[currentImageId]?.();
      this.pendingFullSizeScaleCb[currentImageId] = undefined;
    });
    const realSizeMeasurementLength = Object.values(
      currentImage?.annotations?.RealSizeMeasurementCalibration ?? {}
    )?.[0]?.length;
    if (realSizeMeasurementLength) {
      reduxDispatch(setRealSizeMeasurementDefaultLength(realSizeMeasurementLength));
    }
  };

  cancelRealSizeMeasurementCalibration = () => {
    const { currentImageId } = this;
    this.dispatch(cancelRealSizeCalibration({ imageId: currentImageId }));
    this.switchRealSizeMeasurementCalibration(currentImageId, false, () => {
      this.pendingFullSizeScaleCb[currentImageId] = undefined;
    });
  };

  onSwitchShownAnnotationsTools = () =>
    this.setState(({ showAnnotations }) => ({ showAnnotations: !showAnnotations }));

  setAcquisitionCountDown = (acquisitionCountDown: number) =>
    this.setState({ acquisitionCountDown });

  updateCurrentPatient = (patient: Patient) => {
    this.dispatch(updatePatient({ studyId: this.currentStudyId, patient }));
  };

  updateCurrentPatientRace = (race: string) => {
    this.dispatch(
      updatePatient({
        studyId: this.currentStudyId,
        patient: { ...this.currentStudy.patient, race },
      })
    );
  };

  setComment = (comment: string) =>
    this.setState(
      produce(({ studies }) => {
        _.find(studies, { _id: this.currentStudyId })!.comment = comment;
      })
    );

  setIsCommentDirty = (isCommentDirty: boolean) =>
    this.setState(
      produce(({ studies }) => {
        _.find(studies, { _id: this.currentStudyId })!.isCommentDirty = isCommentDirty;
      })
    );

  setStudyLoadFailedConfirmOpen = (studyLoadFailedConfirmOpen: boolean) =>
    this.setState({ studyLoadFailedConfirmOpen });

  produceCommonToolsList = (update: (toolsList: ToolsStates) => void | ToolsStates) =>
    this.setState(
      produce(({ commonToolsList }) => {
        const updatedCommonToolsList = update(commonToolsList);
        if (!updatedCommonToolsList) return undefined;

        return { commonToolsList: updatedCommonToolsList };
      })
    );

  produceImageToolsList = (updateFn: (toolsList: ToolsStates) => void) => {
    const updatedToolsList = _.cloneDeep(this.currentImage.toolsList);
    updateFn(updatedToolsList);

    this.dispatch(
      updateToolsStates({ imageId: this.currentImageId, toolsState: updatedToolsList })
    );
  };

  /* End state setters */

  /* Study functions */

  onStudyFailureModalClose = () => this.setStudyLoadFailedConfirmOpen(false);

  onCommentChange = (modifiedComment: string) => {
    this.setComment(modifiedComment);
    this.setIsCommentDirty(true);
  };

  onDeleteImageConfirm = () => {
    const { pendingImageIdDeletion } = this.state;
    this.props.studyStore.deleteImage(
      this.images[pendingImageIdDeletion].study,
      pendingImageIdDeletion
    );
    this.dispatch(deleteImage({ imageId: pendingImageIdDeletion }));
    this.setImageForDeletion(undefined);
  };

  onDeleteImageCancel = () => {
    this.setImageForDeletion(undefined);
  };

  /* Study functions end */

  /* Image addition function */

  onImageUpload = async (
    imageFile: LoadableImageFile,
    isSelected = false,
    origin: ImageOrigin = 'upload'
  ) => {
    const { images } = this;
    const { objectIdGenerator, imageLoader, intl } = this.props;

    const imageId = findFirstLoadErrorIndex(images) ?? objectIdGenerator.create();
    this.pendingImageFiles.push([imageId, imageFile]);
    this.dispatch(imageLoadStart({ imageId, origin, isSelected, isNewImage: true, intl }));
    this.registerImagesInLoadingQueue({
      imageId,
      loadFn: () => imageLoader.load(imageFile),
    });
  };

  onImagesUpload = (imageFiles: LoadableImageFile[], origin: ImageOrigin) =>
    imageFiles.forEach((imageFile, index) => this.onImageUpload(imageFile, index === 0, origin));

  onSnipImages = (imageFiles: LoadableImageFile[]) => this.onImagesUpload(imageFiles, 'snip');

  onAutoImportImages = (imageFiles: LoadableImageFile[]) =>
    this.onImagesUpload(imageFiles, 'automaticExport');

  onFileDrop = (event: React.DragEvent<HTMLDivElement>) => {
    event.stopPropagation();
    event.preventDefault();

    if (!this.getSingleStudy()) return;

    const { files } = event.dataTransfer;
    _.times(files.length, (index) => this.onImageUpload(files[index], index === 0));
  };

  onFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!this.getSingleStudy()) return;

    const { files } = event.target;
    _.times(files.length, (index) => this.onImageUpload(files[index], index === 0));
    this.fileInputRef.current.value = '';
  };

  loadImagePaths = () => {
    const { imagePaths, onImagePathsAcknowledged } = this.props;
    if (!imagePaths || imagePaths.length === 0) return;

    this.onImagesUpload([...imagePaths], 'commandLine');
    onImagePathsAcknowledged?.([...imagePaths]);
  };

  loadAutoImportedImages = () => {
    const { importedImages } = this.props;
    if (!importedImages || importedImages.length === 0) return;
    console.log('importedImages', importedImages);
    this.onImagesUpload(importedImages, 'automaticExport');
  };

  triggerFileUpload = () => this.fileInputRef.current.click();

  addWorkListImage = (anatomicRegion: string) => {
    const { objectIdGenerator } = this.props;
    const imageId = objectIdGenerator.create();
    this.dispatch(addWorkListImage({ imageId, anatomicRegion }));
  };

  /* Image upload function end */

  /* Legacy data manipulation */

  makeOldAPIStudy: () => CompatDropzoneStudy = () =>
    this.useMemo(
      'makeOldAPIStudy',
      () => {
        const { intl, dicomBuilder, fileExportSettings, clinicInfo } = this.props;
        const {
          patient,
          comment,
          isCommentDirty,
          _id: studyId,
          images,
          creationDate,
        } = this.currentStudy;

        const study: CompatDropzoneStudy = {
          ID: studyId,
          creationDate,
          animal: patient,
          comment,
          isCommentDirty,
          images: [],
        };

        study.images = _(images)
          .omitBy(isWorkListImage)
          .map((image) => {
            const imageId = image._id;
            const {
              predictions,
              origin,
              displayableImage,
              annotations,
              viewport,
              toolsList,
              displayedMetadata,
              anatomicRegion,
            } = image;

            const visibleAnnotations = fileExportSettings?.isExportAllAnnotations
              ? extractVisibleAnnotations(annotations, toolsList)
              : _.pick(annotations, ['Crop', 'LeftMarker', 'RightMarker']);
            const oldAPIImage: CompatDropzoneImage = {
              id: imageId,
              backendId: imageId,
              viewport,
              annotations: visibleAnnotations,
              predictions,
              origin,
              image: displayableImage,
              metadata: displayedMetadata,
            };

            if (isFullResolutionDicom(image)) {
              oldAPIImage.computeDicomData = () =>
                makeDicomImageFromDetailsAndViewport(
                  {
                    studyId,
                    image: {
                      ...image,
                      annotations: visibleAnnotations,
                    } as DicomExportableImage,
                    patient,
                    imagesOrder: _.map(images, '_id'),
                    transferSyntax: undefined,
                  },
                  {
                    intl,
                    dicomBuilder,
                    clinicInfo,
                  }
                );
            }
            return oldAPIImage;
          })
          .value();

        return study;
      },
      [
        this.props.intl,
        this.props.dicomBuilder,
        this.currentStudy?.patient,
        this.currentStudy?.comment,
        this.currentStudy?.isCommentDirty,
        this.currentStudy?._id,
        this.currentStudy?.images,
        this.props.fileExportSettings?.isExportAllAnnotations,
      ]
    );

  /* Legacy data manipulation end */

  prepareImageForPACSSelection = () =>
    this.useMemo(
      'prepareImageForPACSSelection',
      () => {
        const { images } = this.currentStudy;
        const pacsExportableImages = formatViewerImagesToSelectableImages(
          _.map(images, (image) => ({
            ...image,
            id: image._id,
          })),
          { includeAnnotations: this.props.pacsExportSettings?.isExportAllAnnotations }
        );
        return pacsExportableImages;
      },
      [
        this.props.dicomBuilder,
        this.currentStudy.images,
        this.props.pacsExportSettings?.isExportAllAnnotations,
      ]
    );

  sendSelectedImagesToPACS = (
    images: ReturnType<typeof this.prepareImageForPACSSelection>,
    exportOptions: PACSExportOptions
  ) => {
    _.forEach(images, (image) =>
      this.syncImageWithPACS(image.id, {
        includeAnnotations: exportOptions?.isExportAllAnnotations,
      })
    );
  };

  isAcquisitionStudy = () => {
    const isAcquisitionSoftware = !!xray();
    if (!isAcquisitionSoftware) return false;
    const hasNearAcquisitionImage = _.some(
      this.images,
      (i) => isAcquisitionImage(i) || isWorkListImage(i)
    );
    return hasNearAcquisitionImage;
  };

  /* Image save functions */

  exportImagesToPMSWithSaveGuard = (exportOnInvocation = true) => {
    const { exportToPMS, intl, dataLossGuard } = this.props;
    const {
      pms_id,
      images,
      patient,
      _id: studyId,
      creationDate,
      comment,
      isCommentDirty,
    } = this.currentStudy;

    if (!exportToPMS) {
      dataLossGuard?.setDataSaveCallback(`pms_export`, undefined);
      return;
    }

    const imagesForPMS = _.filter(images, isAcquisitionImage).map((image) => ({
      ...image,
      annotations: extractVisibleAnnotations(image.annotations, image.toolsList),
    }));

    const exportToPMSContinuableFn = memoizeOne(() =>
      exportToPMS(
        { pms_id, comment, creationDate, isCommentDirty, _id: studyId },
        patient,
        imagesForPMS as PMSImagesType
      ).then((results) => {
        if (_.some(results, { status: 'rejected' })) {
          this.exportImagesToPMSWithSaveGuard(false);
          _.filter(results, { status: 'rejected' }).forEach((result: PromiseRejectedResult) => {
            logger.warn('Failed to export image to PACS: ', result.reason);
          });
          throw new UserDisplayableError(
            intl.formatMessage({ id: 'viewer.unsaved_data.pms_export' })
          );
        }

        dataLossGuard?.setDataSaveCallback(`pms_export`, undefined);
      })
    );

    if (exportOnInvocation) exportToPMSContinuableFn();

    dataLossGuard?.setDataSaveCallback(`pms_export`, () => exportToPMSContinuableFn(), {
      taskName: this.props.intl.formatMessage({ id: 'viewer.unsaved_data.pms_export.label' }),
    });
  };

  clearStudy = () => {
    const { history } = this.props;
    const isAcquisitionSoftware = !!xray();
    if (isAcquisitionSoftware) {
      history.push('/acquisition');
    } else {
      history.push('/viewer');
    }
  };

  validateStudy = () => {
    const { images, _id: studyId } = this.currentStudy;
    const { studyStore, viewerConfiguration, reduxDispatch } = this.props;
    const { syncToPACSOnValidate } = viewerConfiguration;

    // Record rotation history for all acquired images before clearing the study
    _.forEach(images, (image) => {
      if (isAcquisitionImage(image) && image.anatomicRegion) {
        const regionKey = getSpeciesAgnosticRegionKey(image.anatomicRegion);
        const normalizedRotation = normalizeRotation(
          image.viewport?.rotation,
          image.viewport?.hflip,
          image.viewport?.vflip
        );
        reduxDispatch(recordRotation({ regionKey, rotation: normalizedRotation }));
      }
    });

    _.forEach(images, (image) => {
      if (isWorkListImage(image)) {
        studyStore.deleteImage(studyId, image._id);
        this.dispatch(deleteImage({ imageId: image._id }));
      }
    });

    if (syncToPACSOnValidate) this.syncWithPACSUsingSaveGuard();
    this.exportImagesToPMSWithSaveGuard();

    this.clearStudy();
  };

  saveImageData = (imageId: string, image: Partial<XRayImage>) => {
    const study = this.getStudyForImageId(imageId);
    return this.props.studyStore
      .updateImage(study._id, imageId, image)
      .then()
      .catch((e) => {
        console.error('Error saving image', e);
        throw new UserDisplayableError(
          this.props.intl.formatMessage(
            { id: 'viewer.unsaved_data.image' },
            { index: _.findIndex(study.images, { _id: imageId }) + 1 }
          )
        );
      });
  };

  saveRawImage = async ({
    studyId,
    imageId,
    dataImage,
    acquisitionDetails,
    dicomData,
  }: RawImageSaveData & { studyId: string; imageId: string }) => {
    const { studyStore, intl } = this.props;
    const study = this.state.studies[studyId];
    try {
      await studyStore.saveRawImage(studyId, imageId, dataImage, acquisitionDetails, dicomData);
      this.dispatch(setRawDataSaved({ imageId }));
    } catch (error) {
      throw new UserDisplayableError(
        intl.formatMessage(
          { id: 'viewer.unsaved_data.dicom' },
          { index: _.findIndex(study.images, { _id: imageId }) + 1 }
        )
      );
    }
  };

  saveLastProcessedImage = (image: ViewerImage, imageId: string) => {
    if (!image.processedImage || image.isFromLastProcessing) return;

    this.props.studyStore.saveLastProcessedImage(image.study, imageId, image.processedImage);
  };

  /* Report save functions start */

  formatReportState = (study: ViewerStudy): ReportState => ({
    comment: study.comment,
    isCommentDirty: study.isCommentDirty,
  });

  saveReport = (studyId: string, { comment, isCommentDirty }: ReportState) =>
    this.props.studyStore.updateReport(studyId, comment, isCommentDirty).catch(() => {
      throw new UserDisplayableError(
        this.props.intl.formatMessage({ id: 'viewer.unsaved_data.report' })
      );
    });

  /* Report save functions end */

  /* Study save functions end */

  /* Pacs save functions start */

  syncImageWithPACS = async (
    imageId: string,
    options?: { signal?: AbortSignal; includeAnnotations: boolean }
  ) => {
    const study = this.getStudyForImageId(imageId);
    const { images, _id: studyId, patient } = study;
    const { studyStore, pacsCommunication, intl, dicomBuilder, dataLossGuard, clinicInfo } =
      this.props;
    const image = this.images[imageId];

    const alreadyOngoingRequest = this.ongoingPACSSyncRequest[imageId];
    if (alreadyOngoingRequest) return alreadyOngoingRequest;

    this.dispatch(pacsStartSync({ imageId }));

    let syncRequest = syncImageWithPACS(
      {
        studyId,
        image: image as DicomExportableImage,
        patient,
        imagesOrder: images.map((img) => img._id),
      },
      { intl, dicomBuilder, pacsCommunication, clinicInfo },
      options
    );

    this.ongoingPACSSyncRequest[imageId] = syncRequest;

    return syncRequest
      .then((result) => {
        if (isOk(result)) {
          this.dispatch(pacsEndSync({ imageId }));
          dataLossGuard?.setDataSaveCallback(`pacs.${imageId}`, undefined);
          studyStore.updateImage(studyId, imageId, {
            image_metadata: { PACS: { isSync: true } },
          });
        } else {
          const syncError = result.error ?? new Error('PACS store failure');
          this.dispatch(pacsEndSync({ imageId, syncError }));

          throw syncError;
        }
      })
      .catch((syncError) => {
        this.dispatch(pacsEndSync({ imageId, syncError }));
        throw syncError;
      })
      .finally(() => {
        this.ongoingPACSSyncRequest[imageId] = undefined;
      });
  };

  syncImageWithPACSUsingSaveGuard = (imageId: string, syncOnCall = true) => {
    const study = this.getStudyForImageId(imageId);
    const { images } = study;
    const { pacsCommunication, PACSConfiguration, intl, dataLossGuard } = this.props;

    const image = _.find(images, { _id: imageId });
    const isPACSSyncNeeded =
      pacsCommunication &&
      !isPACSConfigurationDisabled(PACSConfiguration) && // Redundant condition since disabled PACS leads to no pacsCommunication
      isAcquisitionImage(image) &&
      !image?.image_metadata?.PACS?.isSync;

    if (!isPACSSyncNeeded) {
      dataLossGuard?.setDataSaveCallback(`pacs.${imageId}`, undefined);
      return;
    }

    const abortController = new AbortController();

    const syncWithPACSContinuableFn = memoizeOne(async () => {
      return this.syncImageWithPACS(imageId, {
        signal: abortController.signal,
        includeAnnotations: false,
      })
        .then(() => {
          dataLossGuard?.setDataSaveCallback(`pacs.${imageId}`, undefined);
        })
        .catch(() => {
          this.syncImageWithPACSUsingSaveGuard(imageId, false);

          throw new UserDisplayableError(
            intl.formatMessage(
              { id: 'viewer.unsaved_data.pacs' },
              { index: this.getImageIndex(imageId) + 1 }
            )
          );
        });
    });

    if (syncOnCall) syncWithPACSContinuableFn();

    dataLossGuard?.setDataSaveCallback(`pacs.${imageId}`, () => syncWithPACSContinuableFn(), {
      taskName: this.props.intl.formatMessage(
        {
          id: 'viewer.unsaved_data.pacs.label',
        },
        { index: this.getImageIndex(imageId) + 1 }
      ),
      cancellationWarning: this.props.intl.formatMessage({
        id: 'viewer.unsaved_data.pacs.cancel_warning',
      }),
      onCancel: () => {
        abortController.abort();
      },
    });
  };

  syncWithPACSUsingSaveGuard = () => {
    const { images } = this;

    _.forEach(images, (_image, imageId) => this.syncImageWithPACSUsingSaveGuard(imageId));
  };

  /* PACS save functions end */

  /* Image loading for display */

  isDicomFromAnotherStudy = (dicomData: DicomData) => {
    const { images } = this;
    const currentImageStudyInstanceID = getDicomDataValue(dicomData, 'StudyInstanceUID');
    if (!currentImageStudyInstanceID) return false;

    const existingImportedImagesStudyInstanceID = _.reject(
      _.map(images, (image) => getDicomDataValue(image.dicomData, 'StudyInstanceUID')),
      _.isUndefined
    );
    const isAllStudyInstanceIDMatchCurrent = _.every(
      existingImportedImagesStudyInstanceID,
      (studyInstanceID) => studyInstanceID === currentImageStudyInstanceID
    );
    return !isAllStudyInstanceIDMatchCurrent;
  };

  reloadStudyForNewImportedStudy = () => {
    const { dataLossGuard } = this.props;
    const pendingAutomaticImportedImageFiles = this.pendingImageFiles.map(
      ([_imageId, imageFile]) => imageFile
    );
    if (this.isAutoImportNewStudyChangePending) return;

    this.isAutoImportNewStudyChangePending = true;
    dataLossGuard
      .clearComponentWithDataSave()
      .then(() => this.props.onImportedImagesFromAnotherStudy(pendingAutomaticImportedImageFiles))
      .catch(() => {
        this.isAutoImportNewStudyChangePending = false;
      });
  };

  checkMultiStudyConsistency = () => {
    const { images } = this;
    if (this.pendingImageFiles.length === 0) return;

    this.pendingImageFiles = _.reject(
      this.pendingImageFiles,
      ([pendingImageId]) => images[pendingImageId]?.isImageLoading == false
    );

    if (this.pendingImageFiles.length > 0) {
      const imagesFromAnotherStudy = _.filter(images, (image) => image.isFromAnotherStudy);
      imagesFromAnotherStudy.forEach(({ _id }) => this.dispatch(deleteImage({ imageId: _id })));

      if (imagesFromAnotherStudy.length > 0) {
        this.reloadStudyForNewImportedStudy();
      }
    }
  };

  onImageLoaded = async (imageId: string, loadedImage: LoadedImage) => {
    this.dispatch(
      imageLoadSuccess({
        imageId,
        ...loadedImage,
        isAIOnly: this.props.aiOnlyConfiguration.enabled,
        speciesMapping: this.props.dicomMapping?.species,
      })
    );
  };

  registerImagesInLoadingQueue = (
    ...imagesWithLoadFunction: {
      imageId: string;
      loadFn: () => Promise<LoadedImage>;
    }[]
  ) => {
    imagesWithLoadFunction.forEach(({ imageId, loadFn }) => {
      this.imageLoadingPromises[imageId] = createLoadImagePromise(loadFn);

      this.imageLoadingPromises[imageId]
        .finally(() => {
          this.imagesLoadingHandlers[imageId] = undefined;
        })
        .then(async (loadedImage) => this.onImageLoaded(imageId, loadedImage))
        .catch((error) => {
          logger.error('Image loading error', error);
          this.dispatch(imageLoadFailure({ imageId, loadError: error }));
        });

      this.imagesLoadingHandlers[imageId] = this.imageLoadingScheduler.schedule(
        this.imageLoadingPromises[imageId].load
      );
    });
  };

  onLoadDemo = async () => {
    const { objectIdGenerator, imageLoader, intl } = this.props;

    const demoImages = await Promise.all(loadDemoImages());
    demoImages.forEach((demoImage) => {
      const imageId = objectIdGenerator.create();
      this.dispatch(imageLoadStart({ imageId, origin: 'demo', isNewImage: true, intl }));
      this.registerImagesInLoadingQueue({
        imageId,
        loadFn: () => imageLoader.load(demoImage),
      });
    });
  };

  registerRendererListeners(renderer: ImageRenderer) {
    renderer.addEventListener('annotation_updated', ({ imageId, toolName, measurementData }) => {
      if (toolName === 'Crop') return;
      this.dispatch(updateAnnotation({ imageId, toolName, measurementData }));
    });
    renderer.addEventListener('annotation_completed', ({ imageId, toolName, measurementData }) => {
      this.dispatch(updateAnnotation({ imageId, toolName, measurementData }));
      if (toolName === 'Crop') {
        const image = this.images[imageId];
        const cropMeasurement = measurementData as CropAnnotation;
        if (image.isNotProcessable) return;

        const oldRect = convertCropAnnotationToCropRect(
          image?.annotations?.[toolName]?.[measurementData.uuid]
        );
        const newRect = convertCropAnnotationToCropRect(cropMeasurement);
        if (_.isEqual(oldRect, newRect)) {
          return;
        }
        triggerProcessOnCrop(
          toolName,
          cropMeasurement,
          imageId,
          image.initialDataImage,
          {
            processingType: image.image_metadata?.processingType,
            photometric_interpretation: image?.photometric_interpretation,
          },
          this.processLoadedImage
        );
      }
    });
    renderer.addEventListener('annotation_removed', ({ imageId, toolName, measurementData }) => {
      this.dispatch(removeAnnotation({ imageId, toolName, uuid: measurementData.uuid }));
    });
    renderer.addEventListener('viewport_updated', ({ imageId, viewport }) => {
      this.dispatch(updateViewport({ imageId, viewport }));
    });
  }

  onRendererRef = (mainRenderer: ImageRenderer, negatoViewIndex: number) => {
    const isRefNew = mainRenderer !== this.renderers[negatoViewIndex];
    if (!isRefNew) return;

    this.renderers[negatoViewIndex] = mainRenderer;

    if (!mainRenderer) return;

    this.registerRendererListeners(mainRenderer);
  };

  onComparatorRendererRef = (mainRenderer: ImageRenderer, negatoViewIndex: number) => {
    const isRefNew = mainRenderer !== this.comparatorRenderers[negatoViewIndex];
    if (!isRefNew) return;

    this.comparatorRenderers[negatoViewIndex] = mainRenderer;
  };

  /* Image loading for display end */

  /* Image inference */

  computePredictions = (
    imageId: string,
    retrievePredictionsFn: () => Promise<AllPredictions>,
    firstTry: boolean = true
  ) => {
    this.dispatch(predictionsLoadStart({ imageId }));

    return retrievePredictionsFn()
      .then(async (predictions: AllPredictions) => {
        // No need for complicated logic since we will only retry once on failure
        if (firstTry && (predictions as BadPredictions).error) {
          await this.computePredictions(imageId, retrievePredictionsFn, false);
          return;
        }
        this.dispatch(predictionsLoadSuccess({ imageId, predictions }));
      })
      .catch((error: Error) => {
        this.dispatch(predictionsLoadFailure({ imageId, inferenceError: error }));
        throw error;
      });
  };

  refreshInference = async (imageId: string) =>
    this.computePredictions(imageId, async () => {
      const image = this.images[imageId];
      const additionalParams: Partial<ImageToInfer> = {};
      const possibleCropAnnotation = convertCropAnnotationsToCropRect(image?.annotations?.Crop);
      if (possibleCropAnnotation) {
        additionalParams.cropRect = possibleCropAnnotation;
        additionalParams.imageSize = {
          width: image.displayableImage.width,
          height: image.displayableImage.height,
        };
      }

      return this.props.imageEncoder
        .toBase64((await this.imageLoadingPromises[imageId]).imageData, {
          annotations: _.pick(image.annotations, ['Crop']),
          viewport: _.pick(image.viewport, ['voi']),
        })
        .then((imageBase64) =>
          this.props.inferenceExecutor.refreshInference({
            imageId,
            image: imageBase64,
            ...additionalParams,
          })
        );
    });

  refreshInferenceOnCurrentImage = async () => {
    await this.refreshInference(this.currentImageId);
  };

  async computeInitialInference(imageId: string) {
    return MaxDurationPromise(
      this.computePredictions(imageId, async () => {
        const { inferenceExecutor, imageEncoder } = this.props;
        const { images } = this;

        return inferenceExecutor.infer({
          studyId: images[imageId].study,
          imageId,
          filename: images[imageId].filename,
          origin: images[imageId].origin,
          base64Image: await imageEncoder.toBase64(images[imageId].displayableImage),
        });
      }),
      INFERENCE_GUARD_TIMEOUT
    ).catch((error) => {
      const study = this.getStudyForImageId(imageId);
      const { intl } = this.props;
      logger.error(error);
      throw new UserDisplayableError(
        intl.formatMessage(
          { id: 'viewer.unsaved_data.inference_timeout' },
          { index: _.findIndex(study.images, { _id: imageId }) + 1 }
        )
      );
    });
  }

  /* Image inference end */

  /* Image tools */

  switchVHSState = () => {
    const VHSState = this.currentImage?.toolsList?.VHS?.state;
    if (!VHSState) return;
    const newState = isVisibleToolState(VHSState) ? 'disabled' : 'passive';
    this.dispatch(
      updateToolsStates({ imageId: this.currentImageId, toolsState: { VHS: { state: newState } } })
    );
  };

  setActiveRegionNameForImage = (activeRegionName: string) =>
    this.dispatch(setActiveRegion({ imageId: this.currentImageId, activeRegionName }));

  onFeedbackUpdate = (imageId: string) => (patternName: string, isPositive: boolean) => {
    this.dispatch(updateFeedback({ imageId, patternName, isPositive }));
  };

  updateImageDisplayedMetadata = (image: ViewerImage) => {
    const { intl, clinicInfo } = this.props;
    const study = this.getStudyForImageId(image._id);
    const patient = study?.patient ?? {};

    if (!isAcquisitionImage(image) && !isFullResolutionDicom(image)) return;
    this.dispatch(
      updateDisplayableMetadata({
        imageId: image._id,
        metadata: computeDisplayedImageMetadata(image, patient, clinicInfo, intl),
      })
    );
  };

  updateAllImageDisplayedMetadata = (studyId: string) => {
    _.forEach(this.state.studies[studyId]?.images, this.updateImageDisplayedMetadata);
  };

  /* Image tools end */

  /* Thumbnails callbacks */

  onImageNewAnatomicRegion = (imageId: string, newAnatomicRegion: string) =>
    this.dispatch(updateAnatomicRegion({ imageId, anatomicRegion: newAnatomicRegion }));

  onImageRedo = (imageId: string) =>
    this.dispatch(
      redoImage({ imageId: this.props.objectIdGenerator.create(), imageIdToCopy: imageId })
    );

  onImageDelete = (imageId: string) => this.setImageForDeletion(imageId);

  onImageSelect = (imageId: string) => this.dispatch(imageSelect({ imageId }));

  /* Thumbnails callbacks end */

  /* Processing */

  processWithCache = async (
    savedStudyId: string,
    imageId: string,
    rawImage: DataImage,
    options: ProcessingOptions
  ): Promise<DataImage> => {
    const usedOptions = _.omitBy({ ...options }, _.isUndefined) as ProcessingOptions;
    if (options.crop_rect) {
      usedOptions.crop_rect = usedOptions.crop_rect.map(Math.round);
    }
    logger.time(`Processing for ${imageId}`);
    let processedImage: DataImage = await this.processingCache.getOrCompute(rawImage, usedOptions);
    logger.timeEnd(`Processing for ${imageId}`);
    if (processedImage.collimation_rect) {
      usedOptions.crop_rect ??= processedImage.collimation_rect;
    }
    // if (options?.viewport) {
    //   console.debug('Applying viewport from processing options', options.viewport);
    //   processedImage = { ...processedImage, viewport: options?.viewport };
    // }
    return processedImage;
  };

  processFineTunedImage = (imageId: string, filter: FilterDescription) => {
    this.fineTuningProcessingScheduler.schedule(async () => {
      const image = this.getImageForImageId(imageId); // Ensure image exists
      if (!image) return;
      this.dispatch(processingFineTuningToggle({ imageId, isFineTunedProcessingOngoing: true }));

      try {
        const fineTunedProcessedImage: DisplayableImageData =
          convertDataImageToDisplayableImageData(
            await this.props.imageProcessor.process(
              image.initialDataImage,
              buildProcessingOptions(image, {
                baseParameters: filter.parameters,
                photometricInterpretation: image?.photometric_interpretation,
                isFinetuning: true,
                imageDimensions: image?.displayableImage,
              })
            ),
            `rawUint16:${generateRawUint16ImageId()}`
          );

        this.dispatch(updateFinetunedProcessedImage({ imageId, fineTunedProcessedImage }));
      } catch (error) {
        console.error('Error during fine tuning processing', error);
      }
      this.dispatch(processingFineTuningToggle({ imageId, isFineTunedProcessingOngoing: false }));
    });
  };

  confirmFineTuningFilter = async (filter: FilterDescription) => {
    const { currentImageId } = this;
    const savedFilter = _.cloneDeep(filter) as StoredFilterDescription;
    savedFilter.id ??= v4();

    const ret = this.props.reduxDispatch(
      addListener({
        actionCreator: updateFilter,
        effect: async (action, listenerApi) => {
          this.processLoadedImage(currentImageId, this.currentImage.initialDataImage, {
            processingType: savedFilter.id,
            photometric_interpretation: this.currentImage?.photometric_interpretation,
            cropRect: convertCropAnnotationToCropRectWithScale(
              this.currentImage.annotations?.Crop,
              this.currentImage?.viewport,
              this.currentImage?.displayableImage
            ),
            processingFilters: selectProcessingFilters(listenerApi.getState() as any),
          });
          listenerApi.unsubscribe();
        },
      })
    );

    this.props.reduxDispatch(updateFilter(savedFilter));
    this.dispatch(
      enableConfigurableFilterParameters({
        imageId: currentImageId,
        isEnabled: false,
      })
    );
  };

  deleteFineTuningFilter = async (filter: FilterDescription) => {
    const { currentImageId, currentImage } = this;
    this.props.reduxDispatch(removeFilter(filter.id!));
    this.dispatch(
      enableConfigurableFilterParameters({ imageId: currentImageId, isEnabled: false })
    );

    if (currentImage.image_metadata?.processingType === filter.id) {
      const processingType = getProcessingFromAnatomicRegion(currentImage?.anatomicRegion);

      this.processLoadedImage(currentImageId, this.currentImage.initialDataImage, {
        processingType: processingType,
        photometric_interpretation: this.currentImage?.photometric_interpretation,
        cropRect: convertCropAnnotationToCropRectWithScale(
          this.currentImage.annotations?.Crop,
          this.currentImage?.viewport,
          this.currentImage?.displayableImage
        ),
      });
    }
  };

  processLoadedImage = async (
    imageId: string,
    pixelContent: DataImage,
    {
      processingType,
      cropRect,
      photometric_interpretation,
      processingFilters,
      has_anti_scattering_grid,
    }: ProcessOptions
  ) => {
    const { images } = this;
    const image = images[imageId];

    const processingOptions = buildProcessingOptions(image, {
      processingOptionsProvider: this.props.processingOptionsProvider,
      processingFilters,
      processingType,
      photometricInterpretation: photometric_interpretation,
      hasAntiScatteringGrid: has_anti_scattering_grid,
      cropRect,
    });
    this.dispatch(processingStart({ imageId, processingType }));

    const processedImage = await this.processWithCache(
      images[imageId].study,
      imageId,
      pixelContent,
      processingOptions
    );

    this.dispatch(processingDone({ imageId, processedImage, isNewProcessing: true }));

    this.registerImagesInLoadingQueue({
      imageId,
      loadFn: async () => ({
        imageData: convertDataImageToDisplayableImageData(
          processedImage,
          `rawUint16:${generateRawUint16ImageId()}`
        ),
      }),
    });
  };

  /* Processing end */

  /* Acquisition */

  onGeneratorSwitchChange = (e: Event) => {
    const status = (e as unknown as { status: number }).status;

    console.debug('Pedale switch status changed', { status });
    const { currentImage, currentImageId } = this;
    if (
      status !== 1 || // No pedale switch
      !currentImage?.acquisitionConstants || // No acquisition constants to copy
      !this.state.acquisitionCountDown // No longer during coutndown
    ) {
      return;
    }
    this.clearAcquisitionCountDown();
    this.onImageRedo(currentImageId);
  };

  togglePedaleStateDetection = (shouldDetect: boolean) => {
    if (!this.props.xRayGeneratorController?.requestPedaleStateDetection) return;

    this.props.xRayGeneratorController?.requestPedaleStateDetection?.(shouldDetect);
    if (shouldDetect) {
      this.props.xRayGeneratorController?.on(EVENT_GENERATOR_SWITCH, this.onGeneratorSwitchChange);
    } else {
      this.props.xRayGeneratorController?.removeEventListener(
        EVENT_GENERATOR_SWITCH,
        this.onGeneratorSwitchChange
      );
    }
  };

  onAcquisitionConstantChange = (imageId: string, acquisitionConstants: AcquisitionConstants) => {
    this.dispatch(updateAcquisitionConstants({ imageId, acquisitionConstants }));
  };

  clearAcquisitionCountDown = () => {
    this.togglePedaleStateDetection(false);
    this.setAcquisitionCountDown(undefined);
    clearInterval(this.acquisitionIntervalRef);
  };

  startNextAcquisitionSkipIfNeeded = () => {
    const hasPedaleRequestSystem =
      !!this.props.xRayGeneratorController?.requestPedaleStateDetection;
    const isAnyOtherWorklistImage = _.some(this.images, isWorkListImage);
    if (!isAnyOtherWorklistImage && !hasPedaleRequestSystem) {
      return;
    }

    this.togglePedaleStateDetection(true);
    let acquisitionCount = hasPedaleRequestSystem ? 10 : 5;
    this.setAcquisitionCountDown(acquisitionCount);

    this.acquisitionIntervalRef = setInterval(() => {
      acquisitionCount -= 1;
      this.setAcquisitionCountDown(acquisitionCount);
      if (acquisitionCount <= 0) {
        this.dispatch(selectNextWorklistImage({ imageId: this.currentImageId }));
        this.clearAcquisitionCountDown();
      }
    }, 1000) as unknown as number;
  };

  onNewAcquisitionImage = async (acquiredImage: DataImage) => {
    // Required call to free force JS run loop to handle this code execution outside of the NEW_IMAGE callback.
    console.debug('New acquisition image received', { acquiredImage });
    await undefined;

    const isMultiStudy = !this.getSingleStudy();
    if (isMultiStudy) {
      console.info('Discarding acquired image in multy study context');
      return;
    }

    const { flatPanelState, objectIdGenerator, selectedOperators, intl } = this.props;
    const { _id: studyId, patient } = this.currentStudy;
    const { currentImageId, currentImage } = this;
    let acquiredImageId = currentImageId;
    if (!isWorkListImage(currentImage)) {
      acquiredImageId = objectIdGenerator.create();
    }

    const detectorInfo: AcquiredDetectorInfo = _.cloneDeep(
      getCurrentDetectorState(flatPanelState)?.allAttributes
    );
    detectorInfo.dimensions = {
      width: acquiredImage?.width,
      height: acquiredImage?.height,
    };

    // Get accumulated generator errors/warnings since FIRST_TIME
    const { xRayGeneratorController } = this.props;
    const generatorError = xRayGeneratorController?.getAccumulatedErrors?.();
    const hasGeneratorError =
      generatorError &&
      (generatorError.errorCodes.length > 0 || generatorError.warningCodes.length > 0);

    this.dispatch(
      receiveAcquiredImage({
        imageId: acquiredImageId,
        acquiredImage,
        detectorInfo,
        patient,
        intl: this.props.intl,
        generatorError: hasGeneratorError ? generatorError : undefined,
      })
    );

    // Apply rotation based on configuration
    const { rotationMode, fixedRotationAngle } = this.props;
    if (rotationMode === 'fixed') {
      if (fixedRotationAngle !== 0) {
        this.dispatch(
          updateViewport({
            imageId: acquiredImageId,
            viewport: { rotation: fixedRotationAngle },
          })
        );
      }
    } else if (rotationMode === 'automatic') {
      const acquiredAnatomicRegion =
        currentImage?.anatomicRegion ?? this.currentStudy.patient?.specie;
      if (acquiredAnatomicRegion) {
        const regionKey = getSpeciesAgnosticRegionKey(acquiredAnatomicRegion);
        const { rotationHistory } = this.props;
        const autoRotation = getMostFrequentRotation(rotationHistory[regionKey]);
        if (autoRotation !== undefined && autoRotation !== 0) {
          this.dispatch(
            updateViewport({ imageId: acquiredImageId, viewport: { rotation: autoRotation } })
          );
        }
      }
    }

    const processingType = getProcessingFromAnatomicRegion(currentImage?.anatomicRegion);
    const { processingOptionsProvider } = this.props;
    const processingOptions = buildProcessingOptions(
      (currentImage ?? {}) as Partial<StoredImageInfo>,
      {
        processingOptionsProvider,
        processingType,
        photometricInterpretation: 'MONOCHROME',
        hasAntiScatteringGrid: this.currentStudy.defaultHasAntiScatteringGrid ?? false,
      }
    );

    this.dispatch(processingStart({ imageId: acquiredImageId, processingType }));

    const processedImage = await this.processWithCache(
      studyId,
      acquiredImageId,
      acquiredImage,
      processingOptions
    );

    if (processedImage.collimation_rect) {
      const cropAnnotation = {
        ...convertRectToCropHandles(processedImage.collimation_rect),
        uuid: 'crop_uuid',
      };
      this.dispatch(
        updateAnnotation({
          imageId: acquiredImageId,
          toolName: 'Crop',
          measurementData: cropAnnotation,
        })
      );
    }

    this.dispatch(processingDone({ imageId: acquiredImageId, processedImage }));
    this.dispatch(updateOperators({ imageId: acquiredImageId, operators: selectedOperators }));

    this.startNextAcquisitionSkipIfNeeded();

    this.dispatch(
      imageLoadStart({ imageId: acquiredImageId, origin: 'acquisition', isSelected: true, intl })
    );
    this.registerImagesInLoadingQueue({
      imageId: acquiredImageId,
      loadFn: async () => ({
        imageData: convertDataImageToDisplayableImageData(
          processedImage,
          `rawUint16:${generateRawUint16ImageId()}`
        ),
      }),
    });
  };

  listenForAcquisitionImage = () => {
    const detector = getCurrentDetector(this.props.flatPanelState);

    if (!detector) return undefined;

    const { onNewAcquisitionImage } = this;
    detector.on(DETECTOR_EVENTS.NEW_IMAGE, onNewAcquisitionImage);
    detector.on(DETECTOR_EVENTS.RETRANSFER_IMAGE, onNewAcquisitionImage);
    return () => {
      detector.removeListener(DETECTOR_EVENTS.NEW_IMAGE, onNewAcquisitionImage);
      detector.removeListener(DETECTOR_EVENTS.RETRANSFER_IMAGE, onNewAcquisitionImage);
    };
  };

  /* Acquisition end */

  /* Sub render functions */

  renderAIPanel = () => {
    const {
      isCommentDirty,
      patient,
      _id: studyId,
      creationDate,
      comment,
      images,
    } = this.currentStudy;
    const { intl, viewerConfiguration, clinicInfo } = this.props;
    const { currentImageId, currentImage } = this;
    const isDisplayableImage = currentImage && !isWorkListImage(currentImage);
    const panelStyle = !isDisplayableImage ? { display: 'none' } : {};
    const isMultiStudy = !this.getSingleStudy();

    const {
      annotations,
      predictions,
      isPredictionsLoading,
      inferenceError,
      feedback,
      activeRegionName,
      origin,
    } = currentImage ?? {};

    return (
      <div style={panelStyle}>
        <FoldableAIPanel>
          <div data-testid="image-tools" className="image-tools">
            {isDisplayableImage && (
              <div>
                <EditableReport
                  study={this.makeOldAPIStudy()}
                  onChange={this.onCommentChange}
                  minHeight="95px"
                  maxHeight="225px"
                  isDirty={isCommentDirty}
                />
              </div>
            )}
            {!isMultiStudy && (
              <TeleradiologyPanel
                studyId={studyId}
                animal={patient}
                onAnimalChange={(animal: Patient) => this.updateCurrentPatient(animal)}
                studyDate={creationDate}
                images={formatStudyImagesForTeleradiology(
                  _.mapKeys(images, '_id'),
                  intl,
                  studyId,
                  patient,
                  _.map(images, '_id'),
                  {
                    includeAnnotations:
                      this.props.teleradiologyExportSettings.isExportAllAnnotations,
                  },
                  clinicInfo
                )}
                aiReport={comment}
              />
            )}
            {isDisplayableImage &&
              (viewerConfiguration.isAIAnalysisDisabled ? (
                <div className="ai-disabled-message">
                  <FormattedMessage id="viewer.ai_disabled_locally" />
                </div>
              ) : (
                <PredictionsDisplay
                  origin={origin}
                  switchVHSState={this.switchVHSState}
                  setPatientRace={this.updateCurrentPatientRace}
                  patient={patient}
                  annotations={annotations}
                  activeRegionName={activeRegionName}
                  setActiveRegionName={this.setActiveRegionNameForImage}
                  predictions={predictions}
                  loading={isPredictionsLoading}
                  inferenceError={inferenceError}
                  feedback={feedback}
                  onFeedbackUpdate={this.onFeedbackUpdate(currentImageId)}
                  key={currentImageId}
                />
              ))}
          </div>
        </FoldableAIPanel>
      </div>
    );
  };

  dispatchAnatomicRegion = () => {
    const { currentImage } = this;
    const { anatomicRegionSynchronizer } = this.props;
    anatomicRegionSynchronizer?.setAnatomicRegion(currentImage?.anatomicRegion);
  };

  renderToolsPanel = () => {
    const { currentImage, currentImageId } = this;
    const { processingOptionsProvider } = this.props;
    let appliedFilters;
    if (currentImage?.isFilterFineTuning) {
      appliedFilters = processingOptionsProvider.getProcessingOptions(
        currentImage.image_metadata?.processingType,
        currentImage?.anatomicRegion
      ).parameters;
    }

    return (
      <div>
        {currentImage?.isFilterFineTuning ? (
          <div className="acquisition-pane">
            <FilterParametrization
              referenceFilter={appliedFilters}
              filter={currentImage.filterParameters}
              imageForHist={{
                image: currentImage.fineTunedProcessedImage,
                crop: convertCropAnnotationsToCropRect(currentImage.annotations?.Crop),
              }}
              onChange={(filterParameters) => {
                this.dispatch(
                  updateConfigurableFilterParameters({ imageId: currentImageId, filterParameters })
                );
                this.debouncedProcessImageFineTuned(currentImageId, filterParameters);
              }}
              onConfirm={this.confirmFineTuningFilter}
              onCancel={() => {
                this.dispatch(
                  enableConfigurableFilterParameters({ imageId: currentImageId, isEnabled: false })
                );
              }}
              onDelete={this.deleteFineTuningFilter}
              isFineTunedProcessingOngoing={currentImage.isFineTunedProcessingOngoing}
            />
          </div>
        ) : (
          this.renderAIPanel()
        )}
        {isWorkListImage(currentImage) && (
          <div className="acquisition-pane">
            <XRayGeneratorStatus />
            <Divider style={{ width: '80%' }} />
            <FlatPanelList />
            <Divider style={{ width: '80%' }} />
            <div title={this.props.intl.formatMessage({ id: 'acquisition.grid.toggle.tooltip' })}>
              <Toggle
                checked={this.currentStudy.defaultHasAntiScatteringGrid ?? false}
                size="md"
                checkedChildren={<FormattedMessage id="general.with" />}
                unCheckedChildren={<FormattedMessage id="general.without" />}
                onChange={() =>
                  this.dispatch(
                    setStudyDefaultAntiScatteringGrid({
                      studyId: this.currentStudyId,
                      hasGrid: !(this.currentStudy.defaultHasAntiScatteringGrid ?? false),
                    })
                  )
                }
              >
                <FormattedMessage id="acquisition.grid.toggle.label" />
              </Toggle>
            </div>
            <XRayOperatorSelector />
          </div>
        )}
      </div>
    );
  };

  renderSingleImageRendererView(negatoViewIndex: number) {
    const { selectedNegatoView } = this.state;
    const { images } = this;
    let imageIdToDisplay = _.findKey(images, (image) => image.negatoView === negatoViewIndex);
    const renderedImage = images[imageIdToDisplay];
    const noImageForNegato = !renderedImage;
    const isCurrentNegatoView = selectedNegatoView === negatoViewIndex;

    let imageId: string;
    let image;
    let tools;

    if (!noImageForNegato && !isWorkListImage(renderedImage)) {
      imageId = imageIdToDisplay;
      image = renderedImage;
      tools = image?.toolsList && {
        ...this.state.commonToolsList,
        ...image.toolsList,
      };
    }
    const {
      isImageLoading,
      isProcessingOngoing,
      loadError,
      displayableImage,
      viewport,
      fineTunedViewport,
      annotations,
      displayedMetadata,
      fineTunedProcessedImage,
      isFilterFineTuning,
      isFineTunedProcessingOngoing,
      isSelected,
    } = image ?? {};

    const hiddenRenderer = noImageForNegato || loadError;

    const selectViewIfNotCurrent = !isCurrentNegatoView
      ? () => this.dispatch(selectNegatoView({ viewIndex: negatoViewIndex }))
      : undefined;

    const hasRealSizeMeasurements =
      [
        ...Object.values(annotations?.Length ?? {}),
        ...Object.values(annotations?.CircleRadius ?? {}),
      ].length > 0;
    const hasCalibration =
      Object.values(image?.annotations?.RealSizeMeasurementCalibration ?? {})[0] !== undefined ||
      !!image?.image_metadata?.realSizeMeasurementImageReference;

    return (
      <div
        className={`radio-image-container ${isCurrentNegatoView ? 'selected' : ''}`}
        data-testid="main-radio-image"
        onPointerDown={selectViewIfNotCurrent}
      >
        <Dimmer
          data-testid="image-render-area-loader"
          active={isImageLoading || isProcessingOngoing}
        >
          <Loader size="huge" className="ui loader loaderPerformance" />
        </Dimmer>

        <div className={`radio-view ${hiddenRenderer ? 'no-image' : ''}`}>
          <div style={{ width: '100%', height: '100%', overflow: 'hidden' }}>
            <div style={{ width: '100%', height: '100%', overflow: 'hidden' }}>
              {isFilterFineTuning ? (
                <ImageComparator
                  left={
                    <div className="image-comparator-side-container">
                      <MainImageRenderer
                        imageId={imageId}
                        image={displayableImage}
                        toolsStates={tools}
                        viewport={viewport}
                        annotations={annotations}
                        metadata={displayedMetadata}
                        onRendererRef={(e) => this.onRendererRef(e, negatoViewIndex)}
                        syncedRenderer={this.comparatorRenderers[negatoViewIndex]}
                      />
                      <div className="image-comparator-label left">
                        <FormattedMessage id="general.before" />
                      </div>
                    </div>
                  }
                  // Let all events pass through to the right renderer that will lead all rendering
                  rightStyle={{ pointerEvents: 'none' }}
                  right={
                    // Use scss styles instead of hardcoded
                    <div className="image-comparator-side-container">
                      {isFineTunedProcessingOngoing && (
                        <Label corner="left" color="black">
                          <Icon name="cog" loading />
                        </Label>
                      )}
                      <MainImageRenderer
                        imageId={imageId}
                        image={fineTunedProcessedImage}
                        toolsStates={tools}
                        viewport={{ ...viewport, ...fineTunedViewport }}
                        annotations={annotations}
                        metadata={displayedMetadata}
                        onRendererRef={(e) => this.onComparatorRendererRef(e, negatoViewIndex)}
                        // syncedRenderer={this.renderers[negatoViewIndex]}
                      />
                      <div className="image-comparator-label right">
                        <FormattedMessage id="general.after" />
                      </div>
                    </div>
                  }
                />
              ) : (
                <MainImageRenderer
                  imageId={imageId}
                  image={isFilterFineTuning ? fineTunedProcessedImage : displayableImage}
                  toolsStates={tools}
                  viewport={viewport}
                  annotations={annotations}
                  metadata={displayedMetadata}
                  onRendererRef={(e) => this.onRendererRef(e, negatoViewIndex)}
                />
              )}
            </div>
          </div>
          <div className="image-render-warnings-container">
            {hasRealSizeMeasurements && !hasCalibration && (
              <div className="image-render-warning-item" data-testid="measurement-warning">
                <Popup
                  content={<FormattedMessage id="viewer.measurement_warning" />}
                  trigger={<i className="svg-icon ruler-warning" />}
                  position="bottom center"
                />
              </div>
            )}
            <AcquisitionGeneratorErrorWarning
              generatorError={image?.image_metadata?.generatorError}
              isDismissed={!isSelected || image?.isGeneratorErrorDismissed}
              onChange={(isDismissed) =>
                imageId && this.dispatch(switchGeneratorError({ imageId, isDismissed }))
              }
            />
          </div>
        </div>

        {loadError && (
          <div className="image-load-failure">
            <div>
              <Icon name="warning sign" />
              <FormattedMessage id="dropzone.image_load.failure" />
            </div>
          </div>
        )}
        {noImageForNegato && (
          <div className="negato-no-image">
            <div>
              <Icon name="info" circular />
              <FormattedMessage id="dropzone.negato.no_image_to_display" />
            </div>
          </div>
        )}
      </div>
    );
  }

  renderImageViewer() {
    const { negatoMode } = this.state;
    const isSelected = !isWorkListImage(this.currentImage);
    const selectedClass = isSelected ? 'selected' : '';
    const { viewCount = 1 } = NEGATO_MODE_INFO[negatoMode];

    return (
      <div className={`main-radio-image ${selectedClass}`}>
        <div className={`${negatoMode}`}>
          {this.renderSingleImageRendererView(0)}
          {viewCount >= 2 && this.renderSingleImageRendererView(1)}
          {viewCount >= 3 && this.renderSingleImageRendererView(2)}
          {viewCount >= 4 && this.renderSingleImageRendererView(3)}
        </div>
      </div>
    );
  }

  renderViewerPane = () => {
    const { PACSConfiguration, xRayGeneratorController } = this.props;
    const { images } = this;
    const { selectedNegatoView } = this.state;
    const { patient } = this.currentStudy;

    const { acquisitionCountDown } = this.state;
    const { currentImage, isAnyImagePresent, currentImageToolsList } = this;
    const { isAnyImageLoaded, fileInputRef, toolsProps } = this;

    const isPACSActivated = !isPACSConfigurationDisabled(PACSConfiguration);
    const imagesForPACS = isPACSActivated ? this.prepareImageForPACSSelection() : undefined;
    imagesForPACS?.filter((image) => !image.image_metadata?.PACS?.isSync) ?? [];
    const currentRenderer = this.renderers[selectedNegatoView];
    const focusedElement = currentRenderer?.element;

    const { name, owner_name, sex, birth_date, file_id, specie } = patient ?? {};
    const placeHolderDisplayClassName = isAnyImagePresent ? 'hidden' : '';
    const { isRealSizeMeasurementCalibration, isProcessingOngoing } = currentImage ?? {};
    const hasPedaleRequestSystem =
      !!this.props.xRayGeneratorController?.requestPedaleStateDetection;

    return (
      <>
        {isAnyImageLoaded && (
          <div className="patient-info-bar-wrapper">
            <PatientInfoBar
              animalName={name}
              ownerName={owner_name}
              sex={sex}
              birthDate={birth_date}
              fileID={file_id}
              specie={specie}
            />
            <PatientInfoModal
              initialPatientData={patient}
              onPatientSave={({ animal }: { animal: Patient }) => this.updateCurrentPatient(animal)}
            />
          </div>
        )}
        {currentImageToolsList && (
          <ToolsBar
            predictions={currentImage.predictions}
            toolsList={currentImageToolsList}
            focusedElement={focusedElement}
            produceCommonToolsList={this.produceCommonToolsList}
            produceImageToolsList={this.produceImageToolsList}
            displayedToolsLists={UPPER_TOOLS_BAR_TOOLS_LISTS}
            toolsProps={toolsProps}
            anatomicRegion={currentImage.anatomicRegion}
            disabled={currentImage.disabledTools}
          />
        )}
        <div className="radio-wrapper">
          <picture id="radioPicture">
            <div
              data-testid="file-upload-placeholder"
              className={`placeholderForImagesWrapper ${placeHolderDisplayClassName}`}
            >
              {!isAnyImageLoaded && <WhatImagesToSend loadDemo={this.onLoadDemo} />}
              <div className="placeholderForImagesButtonWrapper">
                <button
                  className="placeholder placeholderForImage"
                  onClick={this.triggerFileUpload}
                  type="button"
                >
                  <label htmlFor="file-upload">
                    <FormattedMessage id="dropzone.dragAndDropText.notIE" />
                  </label>
                  <div>
                    <Icon name="upload" size="huge" className="icon-upload-color" />
                  </div>
                </button>
              </div>
              <input
                id="file-upload"
                type="file"
                data-testid="file-upload"
                accept=".jpg,.JPG,.png,.PNG,.dcm,.DCM,.dicom,.DICOM,.JPEG,.jpeg"
                onChange={this.onFileUpload}
                ref={fileInputRef}
                style={{ display: 'none' }}
                multiple
              />
            </div>
            {this.renderImageViewer()}
            {_.map(images, (image, imageId) => {
              const { isProcessingOngoing, isSelected } = image;
              const selectedClass = isSelected ? 'selected' : '';

              if (!isWorkListImage(image)) return null;
              return (
                <div
                  key={imageId}
                  className={`main-radio-image ${selectedClass}`}
                  data-testid="xray-area-image"
                >
                  <XRayAreaView
                    image={image as React.ComponentProps<typeof XRayAreaView>['image']}
                    animal={this.state.studies[image.study]?.patient}
                    onChange={(acquisitionConstants) =>
                      this.onAcquisitionConstantChange(imageId, acquisitionConstants)
                    }
                    isProcessingOnGoing={isProcessingOngoing}
                    isFocused={isSelected}
                  />
                </div>
              );
            })}
            {isRealSizeMeasurementCalibration && (
              <ToolValidationOverlay
                onConfirm={this.confirmRealSizeMeasurementCalibration}
                onCancel={this.cancelRealSizeMeasurementCalibration}
              />
            )}
          </picture>

          {currentImageToolsList && (
            <div className="tools-bar-side-container">
              <ToolsBar
                predictions={currentImage.predictions}
                toolsList={currentImageToolsList}
                focusedElement={focusedElement}
                produceCommonToolsList={this.produceCommonToolsList}
                produceImageToolsList={this.produceImageToolsList}
                displayedToolsLists={[
                  ['AnnotationsDisplaySwitch'],
                  ['Length', 'Angle', 'ExternalAngle', 'CircleRadius'],
                  ['NorbergOlsson', 'VHS', 'TPLO', 'DistractionIndex'],
                ]}
                toolsProps={toolsProps}
                anatomicRegion={currentImage.anatomicRegion}
                disabled={currentImage.disabledTools}
                direction="vertical"
              />
            </div>
          )}
        </div>

        {acquisitionCountDown !== undefined && (
          <div className={`acquisition-countdown ${hasPedaleRequestSystem ? 'with-switch' : ''}`}>
            {hasPedaleRequestSystem && (
              <span>
                <FormattedMessage id="dropzone.xray_generator.redo" />
              </span>
            )}
            <CountDown count={acquisitionCountDown} duration={hasPedaleRequestSystem ? 10 : 5} />
          </div>
        )}
      </>
    );
  };

  /* Sub render functions end */

  /* Effects */
  onAnnotationDisplayChange = () => {
    const { showAnnotations } = this.state;
    const { images } = this;
    _.forEach(images, (image, imageId) => {
      this.dispatch(changeAnnotationsVisibility({ imageId, showAnnotations }));
    });
  };

  onFullScreenChange = () => {
    this.props.hideHeader(this.state.isFullScreen);
  };

  loadStudy = () => {
    const {
      initialStudyIds,
      initialStudyInstanceUids,
      studyStore,
      imageLoader,
      objectIdGenerator,
      pacsCommunication,
    } = this.props;

    if (!initialStudyIds && !initialStudyInstanceUids) return;

    // Reset initial dummy study data;
    this.setState({ studies: {} });

    const getStudyRequest = initialStudyIds
      ? studyStore.getStudies(initialStudyIds)
      : Promise.all(
          _.map(initialStudyInstanceUids, (uid) =>
            importDicomStudy(uid, {
              studyStore,
              pacsCommunication,
              objectIdGenerator,
            })
          )
        );

    getStudyRequest
      .then((studies) =>
        studies.map(({ images, ...study }) => {
          const { _id: studyId } = study;
          this.dispatch(loadStudy(study));

          images.forEach(async (image) => {
            const imageId = image._id;
            const {
              predictions,
              feedback,
              annotations,
              viewport,
              anatomicRegion,
              image_metadata,
              acquisitionConstants,
              origin,
              operators,
            } = image;

            if (isWorkListImage(image)) {
              this.dispatch(
                loadWorkListImage({
                  studyId,
                  imageId,
                  anatomicRegion,
                  acquisitionConstants,
                })
              );
            } else {
              this.imageLoadingPromises[imageId] = createDeferredPromise();
              this.dispatch(
                imageLoadStart({
                  studyId,
                  imageId,
                  annotations,
                  viewport,
                  image_metadata,
                  origin,
                  operators,
                  anatomicRegion,
                  acquisitionConstants,
                  acquisitionTime: image.acquisitionTime,
                  detectorInfo: image.detectorInfo,
                  feedback,
                  isNewImage: false,
                  intl: this.props.intl,
                })
              );
              this.dispatch(predictionsLoadSuccess({ imageId, predictions }));
            }
          });
          const imagesWithLoadFn = _.reject(images, isWorkListImage).map((image) => ({
            imageId: image._id,
            loadFn: async () => {
              const { _id: imageId } = image;
              const loadedImage = await studyStore.loadImage(studyId, imageId, image);
              this.dispatch(cacheInitialContent({ imageId, imageData: loadedImage.imageData }));

              const imageDescriptor = this.getImageForImageId(imageId);

              if (!isProcessingForImageNeeded(loadedImage, imageDescriptor)) {
                console.debug(
                  `No processing needed for image ${imageId}, returning loaded image directly.`
                );
                return loadedImage;
              }
              const processingType = imageDescriptor?.image_metadata?.processingType;
              this.dispatch(processingStart({ imageId, processingType, isReload: true }));
              this.dispatch(
                updateProcessingOptions({
                  imageId,
                  photometric_interpretation: getDicomDataValue(
                    loadedImage.dicomData,
                    'PhotometricInterpretation'
                  ),
                })
              );
              const { processedImage, isFromLastProcessing } = await processLoadingImage(
                studyId,
                imageId,
                loadedImage,
                imageDescriptor,
                this.processWithCache,
                this.processingCache,
                this.props.processingOptionsProvider
              );

              this.dispatch(processingDone({ imageId, processedImage, isFromLastProcessing }));
              const [rowPixelSpacing, columnPixelSpacing] =
                getPixelSpacing(loadedImage.dicomData) || [];
              return {
                ...loadedImage,
                imageData: {
                  rowPixelSpacing,
                  columnPixelSpacing,
                  ...convertDataImageToDisplayableImageData(
                    processedImage,
                    `rawUint16:${generateRawUint16ImageId()}`
                  ),
                },
              };
            },
          }));
          this.registerImagesInLoadingQueue(...imagesWithLoadFn);
        })
      )
      .catch(() => this.setStudyLoadFailedConfirmOpen(true));
  };

  // startFullSizeConfiguration = () => {
  //   onFullSizeConfigurationToggle(
  //     this.state.isFullSizeConfiguration,
  //     this.currentImageToolsList,
  //     this.produceImageToolsList,
  //     this.produceCommonToolsList
  //   );
  // };

  forceLoadOnImageSelect = ({ isSelected, displayableImage }: ViewerImage, imageId: string) => {
    if (!isSelected) return;
    if (displayableImage) return;
    this.imageLoadingScheduler.forceExecution(this.imagesLoadingHandlers[imageId]);
  };

  updateReportOnChange = () => {
    const { reportGenerator, intl } = this.props;
    const { isCommentDirty, patient, images, creationDate } = this.currentStudy;
    if (isCommentDirty) return;
    this.setComment(
      reportGenerator.generate(intl, patient, _.mapKeys(images, '_id'), creationDate)
    );
  };

  cleanupExecutionContextOnDelete = (image: ViewerImage, imageId: string) => {
    const { dataLossGuard } = this.props;

    if (image !== undefined) return;

    dataLossGuard?.setDataSaveCallback(`inference.${imageId}`, undefined);
    dataLossGuard?.setDataSaveCallback(`pacs.${imageId}`, undefined);
  };
  /* Effects end */

  render() {
    const {
      initialStudyIds,
      initialStudyInstanceUids,
      flatPanelState,
      studyStore,
      imagePaths,
      importedImages,
      PACSConfiguration,
      intl,
      dataLossGuard,
      clinicInfo,
    } = this.props;

    const { isFullScreen, studies } = this.state;
    const { studyLoadFailedConfirmOpen, showAnnotations, pendingImageIdDeletion } = this.state;
    const { acquisitionCountDown } = this.state;
    const onlyStudyId = Object.keys(studies)?.length === 1 ? Object.keys(studies)[0] : undefined;
    const isMultiStudy = !onlyStudyId;

    const isPACSActivated = !isMultiStudy && !isPACSConfigurationDisabled(PACSConfiguration);
    const imagesForPACS = isPACSActivated ? this.prepareImageForPACSSelection() : undefined;
    const initialSelectedImages =
      imagesForPACS?.filter((image) => !image.image_metadata?.PACS?.isSync) ?? [];
    const detector = getCurrentDetector(flatPanelState);

    const onMouseMove = acquisitionCountDown ? this.clearAcquisitionCountDown : undefined;

    return (
      <>
        <div
          data-testid="viewer"
          className={`dropzone viewer-background${isFullScreen ? ' fullscreen' : ''}`}
          onDrop={this.onFileDrop}
          onDragOver={preventDefault}
          onMouseMove={onMouseMove}
        >
          <div className="viewer-grid">
            <div className="left-pane">
              <div>
                <ThumbnailsList
                  studies={studies}
                  onRedo={this.onImageRedo}
                  onDelete={this.onImageDelete}
                  onNewAnatomicRegion={this.onImageNewAnatomicRegion}
                  onSelect={this.onImageSelect}
                />
                <div className="add-image-tools">
                  <Button.Group vertical>
                    {onlyStudyId && flatPanelState && (
                      <AddXRayViewModal
                        specie={studies[onlyStudyId]?.patient?.specie}
                        onNewAnatomicRegion={this.addWorkListImage}
                      />
                    )}
                    {!this.isAcquisitionStudy() && !isMultiStudy && (
                      <>
                        <Popup
                          position="right center"
                          trigger={
                            <button
                              type="button"
                              className="button picoxia add-image"
                              onClick={this.triggerFileUpload}
                            >
                              <Icon name="image outline" size="large" />
                              <span>
                                <FormattedMessage id="dropzone.add_file" />
                              </span>
                            </button>
                          }
                          content={<FormattedMessage id="dropzone.add_file.tooltip" />}
                        />
                        <Snipper onImageReady={this.onSnipImages} />
                        <FileWatcher onImageReady={this.onAutoImportImages} />
                      </>
                    )}
                  </Button.Group>
                </div>
                <div className="left-pane-divider" />

                <div className="study-actions">
                  <div className={`icons-list ${isPACSActivated ? 'with-pacs' : ''}`}>
                    {!isMultiStudy && (
                      <>
                        <ButtonStudySave validateStudy={this.validateStudy} />
                        {isPACSActivated && (
                          <div>
                            <PACSImagesSelector
                              images={imagesForPACS}
                              initialSelectedImages={initialSelectedImages}
                              onConfirm={this.sendSelectedImagesToPACS}
                            />
                          </div>
                        )}
                        <ExportStudyModal currentStudy={this.makeOldAPIStudy()} />
                      </>
                    )}
                    <Popup
                      trigger={
                        <button
                          className="picoxia"
                          type="button"
                          data-testid="clear-study"
                          onClick={this.clearStudy}
                        >
                          <Icon name="close" size="big" />
                        </button>
                      }
                      content={<FormattedMessage id="dropzone.get_out.tooltip" />}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="viewer-pane" data-testid="viewer-panel">
              {this.renderViewerPane()}
            </div>
            <div className="analysis-support-panel" data-testid="analysis-support-panel">
              {this.renderToolsPanel()}
            </div>
          </div>
          <Confirm
            header={intl.formatMessage({ id: 'dropzone.study_load.failure' })}
            open={studyLoadFailedConfirmOpen}
            onClose={this.onStudyFailureModalClose}
            onCancel={this.onStudyFailureModalClose}
            onConfirm={() => {
              dataLossGuard?.clearComponentWithDataSave();
            }}
            cancelButton={intl.formatMessage({ id: 'general.cancel' })}
            confirmButton={intl.formatMessage({ id: 'general.retry' })}
          />
          <Confirm
            header={intl.formatMessage({ id: 'viewer.image.delete.header' })}
            content={intl.formatMessage({ id: 'viewer.image.delete.content' })}
            open={pendingImageIdDeletion !== undefined}
            onConfirm={this.onDeleteImageConfirm}
            onClose={this.onDeleteImageCancel}
            onCancel={this.onDeleteImageCancel}
            cancelButton={intl.formatMessage({ id: 'general.cancel' })}
            confirmButton={
              <Button negative>
                <FormattedMessage id="general.confirm" />
              </Button>
            }
          />
        </div>
        <UseEffect setup={this.onAnnotationDisplayChange} deps={[showAnnotations]} />
        <UseEffect setup={this.onFullScreenChange} deps={[isFullScreen]} />
        <UseEffect
          setup={this.loadStudy}
          deps={[studyStore, initialStudyIds, initialStudyInstanceUids]}
        />
        <UseEffect setup={this.loadImagePaths} deps={[imagePaths]} />
        <UseEffect setup={this.loadAutoImportedImages} deps={[importedImages]} />
        <UseEffect setup={this.listenForAcquisitionImage} deps={[detector]} />
        <UseEffect setup={this.dispatchAnatomicRegion} deps={[this.currentImage?.anatomicRegion]} />
        {_.map(studies, (study) => {
          const { images, patient, comment, saveState, _id: studyId } = study;
          return (
            <Fragment key={studyId}>
              {patient && (
                <DataSaveEffect
                  data={patient}
                  initialData={saveState?.patient}
                  saveCallback={(patient) =>
                    this.props.studyStore.updatePatient(studyId, patient).then((savedPatient) => {
                      this.dispatch(
                        updatePatient({ studyId, patient: savedPatient, isSaved: true })
                      );
                    })
                  }
                  dataLossKey={`patient.${studyId}`}
                  taskName={this.props.intl.formatMessage({
                    id: 'viewer.unsaved_data.patient.label',
                  })}
                />
              )}
              <UseEffect
                setup={() => this.updateAllImageDisplayedMetadata(studyId)}
                deps={[patient, clinicInfo]}
              />

              <UseImagesEffect
                effect={rejectImageDeletionEffect(this.updateImageDisplayedMetadata)}
                images={images}
                deps={[
                  'dicomData',
                  'anatomicRegion',
                  'acquisitionTime',
                  'acquisitionConstants',
                  'detectorInfo',
                  'initialDataImage',
                  'operators',
                ]}
              />
              <UseImagesEffect
                effect={this.checkMultiStudyConsistency}
                images={images}
                deps={['isImageLoading', 'isFromAnotherStudy']}
              />
              <UseImagesEffect
                effect={rejectImageDeletionEffect(this.saveLastProcessedImage)}
                images={images}
                deps={['processedImage']}
              />
              <UseImagesEffect
                effect={rejectImageDeletionEffect(this.forceLoadOnImageSelect)}
                images={images}
                deps={['isSelected']}
              />
              <UseImagesEffect
                effect={rejectImageDeletionEffect(this.onAnnotationDisplayChange)}
                images={images}
                deps={['toolsList']}
              />
              <UseImagesEffect
                effect={this.updateReportOnChange}
                images={images}
                deps={['predictions', 'feedback']}
              />
              <UseImagesEffect
                effect={this.updateReportOnChange}
                images={images}
                deps={['annotations.VHS', 'annotations.NorbergOlsson']}
              />
              <UseImagesEffect
                effect={this.clearAcquisitionCountDown}
                images={images}
                deps={['isSelected']}
              />
              <UseImagesEffect effect={this.cleanupExecutionContextOnDelete} images={images} />
              {comment && (
                <DataSaveEffect
                  data={this.formatReportState(study)}
                  initialData={study.saveState.report}
                  saveCallback={(reportData) => this.saveReport(studyId, reportData)}
                  debounceDelay={ANNOTATION_SAVE_DELAY}
                  dataLossKey={`report.${studyId}`}
                  taskName={this.props.intl.formatMessage({
                    id: 'viewer.unsaved_data.report.label',
                  })}
                />
              )}
              {_.map(images, (image) => {
                return (
                  <Fragment key={image._id}>
                    <DataSaveEffect
                      data={image.saveState?.acquisitionInfo}
                      initialData={image.reloadedState?.acquisitionInfo}
                      saveCallback={(data) =>
                        this.saveImageData(image._id, { ...data, origin: image.origin })
                      }
                      dataLossKey={`image.${image._id}.metadata`}
                      taskName={this.props.intl.formatMessage(
                        { id: 'viewer.unsaved_data.image.label' },
                        { index: this.getImageIndex(image._id) + 1 }
                      )}
                    />
                    <DataSaveEffect
                      data={image.saveState?.viewer}
                      initialData={image.reloadedState?.viewer}
                      saveCallback={(data) => this.saveImageData(image._id, data)}
                      debounceDelay={ANNOTATION_SAVE_DELAY}
                      dataLossKey={`image.${image._id}.viewer`}
                      taskName={this.props.intl.formatMessage(
                        { id: 'viewer.unsaved_data.image.label' },
                        { index: this.getImageIndex(image._id) + 1 }
                      )}
                    />
                    {image.needRawSave && isFullResolutionDicom(image) && (
                      <DataSaveEffect
                        data={image.saveState?.rawImage}
                        initialData={image.reloadedState?.rawImage}
                        saveCallback={(data) =>
                          this.saveRawImage({ studyId, imageId: image._id, ...data })
                        }
                        onlyGuard={image.isRawSavedOnce}
                        dataLossKey={`dicom.${image._id}`}
                        taskName={this.props.intl.formatMessage(
                          { id: 'viewer.unsaved_data.dicom.label' },
                          { index: this.getImageIndex(image._id) + 1 }
                        )}
                      />
                    )}
                    {!image.isImageLoading &&
                      image.displayableImage &&
                      (!image.predictions || _.isEmpty(image.predictions)) && (
                        <DataSaveEffect
                          data={true}
                          saveCallback={() => this.computeInitialInference(image._id)}
                          dataLossKey={`inference.${image._id}`}
                          taskName={this.props.intl.formatMessage(
                            { id: 'viewer.unsaved_data.inference_timeout.label' },
                            { index: this.getImageIndex(image._id) + 1 }
                          )}
                        />
                      )}
                  </Fragment>
                );
              })}
            </Fragment>
          );
        })}
      </>
    );
  }
}

function Viewer(props: ViewerProps) {
  const injections = {
    flatPanelState: useContext(FlatPanelStateContext),
    xRayGeneratorController: useContext(XRayGeneratorControllerContext),
    pacsCommunication: useContext(PACSCommunicationContext),
    dataLossGuard: useContext(DataLossGuardConnectorContext),
    exportToPMS: useContext(PMSExportContext),
    imageEncoder: useContext(IDisplayableImageEncoderContext),
    dicomBuilder: useContext(DicomBuilderContext),
    anatomicRegionSynchronizer: useAnatomicRegionSynchronyzer(),
    selectedOperators: useSelector(selectXRaySelectedOperators),
    aiOnlyConfiguration: useSelector(selectAiOnlyConfiguration),
    viewerConfiguration: useSelector(selectViewerConfiguration),
    PACSConfiguration: useSelector(selectPACSConfiguration),
    dicomMapping: useSelector(selectDicomMapping),
    selectedCurrentStudyId: useSelector(selectCurrentStudyId),
    selectedCurrentImageId: useSelector(selectCurrentImageId),
    teleradiologyExportSettings: useSelector(selectTeleradiologyExportSettings),
    fileExportSettings: useSelector(selectFileExportSettings),
    pacsExportSettings: useSelector(selectPacsExportSettings),
    processingFilters: useSelector(selectProcessingFilters),
    processingOptionsProvider: useProcessingOptionsProvider(),
    rotationHistory: useSelector(selectRotationHistory),
    rotationMode: useSelector(selectRotationMode),
    fixedRotationAngle: useSelector(selectFixedRotationAngle),
    reduxDispatch: useDispatch(),
    intl: useIntl(),
    clinicInfo: useSelector(selectClinicInfo),
  };
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <ViewerImpl {...props} {...injections} />;
}

export default Viewer;
